<template lang="pug">
  b-modal#memberDetails(
    ref="memberDetails"
    :title='$t("ui.combine.member_details")'
    centered
    no-fade
    no-close-on-backdrop
    ok-only
    size="xl"
    :busy="loading"
    @show="reset"
    @shown="shown")
    template(v-if="memberId != ''")
      div(v-if="mbmFound != null")
        template(v-if="member == null")
          div.row
            div.col-md-12.mb-1
              div.row.mb-1
                div.col-md-3.mb-1
                  h1
                    span.errormessage {{ $t('message.no_member_found') }}
        template(v-else)
          .accordion(role='tablist')
            b-card.mb-1(no-body='')
              b-card-header.p-1(header-tag='header' role='tab')
                b-button.btn.btn-link(block='' v-b-toggle.accordion-1='' variant='info') {{ $t('ui.statement_info') }}
              b-collapse#accordion-1(visible=''  role='tabpanel')
                b-card-body
                  div.row
                    div.col-sm-12.col-md-12.col-lg-12
                      div.row
                        div.col-sm-12.col-md-3.col-lg-3
                          div.card.card-accent-info
                            div.card-header
                              i.fas.fa-dollar-sign
                              span.font-weight-bold(:title="$t('ui.turnover')") {{ $t("ui.turnover") }}
                              span.badge.badge-info.float-right {{ currentMonth }}
                            div.card-body
                              div
                                div.text-value
                                  h1(:class="$helpers.fontClassName(validTurnover)" :title="$n(validTurnover, 'currency')") {{ $n(validTurnover, 'currency') }}
                        div.col-sm-12.col-md-3.col-lg-3
                          div.card.card-accent-warning
                            div.card-header
                              i.fas.fa-money-bill-wave
                              span.font-weight-bold(:title="$t('ui.winlose')") {{ $t("ui.winlose") }}
                              span.badge.badge-info.float-right {{ currentMonth }}
                            div.card-body
                              div
                                div.text-value
                                  h1(:class="$helpers.fontClassName(winlose)" :title="$n(winlose, 'currency')") {{ $n(winlose, 'currency') }}
                        div.col-sm-12.col-md-3.col-lg-3
                          div.card.card-accent-success
                            div.card-header
                              i.fas.fa-money-bill-alt
                              span.font-weight-bold(:title="$t('ui.deposit_amount')") {{ $t("ui.deposit_amount") }}
                              //- span.badge.badge-info.float-right {{ currentMonth }}
                            div.card-body
                              div
                                div.text-value
                                  h1(:class="$helpers.fontClassName(member.deposit_amount)" :title="$n(member.deposit_amount, 'currency')") {{ $n(member.deposit_amount, 'currency') }}
                        div.col-sm-12.col-md-3.col-lg-3
                          div.card.card-accent-danger
                            div.card-header
                              i.fas.fa-coins
                              span.font-weight-bold(:title="$t('ui.withdrawal_amount')") {{ $t("ui.withdrawal_amount") }}
                              //- span.badge.badge-info.float-right {{ currentMonth }}
                            div.card-body
                              div
                                div.text-value
                                  h1(:class="$helpers.fontClassName(member.withdrawal_amount)" :title="$n(member.withdrawal_amount, 'currency')") {{ $n(member.withdrawal_amount, 'currency') }}
                        div.col-sm-12.col-md-3.col-lg-3
                              div.card.card-accent-info
                                div.card-header
                                  i.fa.fa-calendar
                                  span.font-weight-bold(:title="$t('ui.ftd')") {{ $t("ui.ftd") }}
                                  span.badge.badge-info.float-right {{ currentMonth }}
                                div.card-body
                                  div
                                    div.text-value
                                      h1(:class="$helpers.fontClassName(ftdAmount)" :title="$n(ftdAmount, 'currency')") {{ $n(ftdAmount, 'currency') }}
                                    div.text-uppercase.text-muted(:title="$moment(ftdDate).format('YYYY-MM-DD, HH:mm:ss')" v-if="ftdDate") {{ $t("ui.ftd_date") }} : {{ $moment(ftdDate).format('YYYY-MM-DD, HH:mm:ss') }}
                  div.row
                    div.col-sm-12.col-md-10.col-lg-12
                      b-form-group(:label="$t('ui.deposit')")
                        table.tablex(width="100%" v-columns-resizable)
                          thead
                            tr
                              th(width="15%")
                                span(:title="$t('ui.date')") {{ $t("ui.date") }}
                              th(width="15%")
                                span(:title="$t('ui.deposit')") {{ $t("ui.deposit") }}
                              th(width="15%")
                                span(:title="$t('ui.bonus')") {{ $t("ui.bonus") }}
                              th(width="15%")
                                span(:title="$t('ui.ticket_id')") {{ $t("ui.ticket_id") }}
                              th(width="10%")
                                span(:title="$t('ui.mode')") {{ $t("ui.mode") }}
                              th(width="15%")
                                span(:title="$t('ui.payment_gateway')") {{ $t("ui.payment_gateway") }}
                              th(width="10%")
                                span(:title="$t('ui.promo_id')") {{ $t("ui.promo_id") }}
                              th(width="20%")
                                span(:title="$t('ui.promo_name')") {{ $t("ui.promo_name") }}
                          tbody
                            tr(v-if="depositList.length == 0")
                              td(colspan="8").text-center
                                span {{ $t('message.no_data_available') }}
                            tr(v-for="(item, index) in depositList")
                              td
                                span(:title="$moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss') }}
                              td
                                span(:title="$n(item.amount, 'currency')") {{ $n(item.amount, 'currency') }}
                              td
                                span(:title="$n(item.bonus_amount, 'currency')") {{ $n(item.bonus_amount, 'currency') }}
                              td
                                span(:title="item.ticket_id") {{ item.ticket_id }}
                              td
                                span(:title="item.payment_option") {{ item.payment_option }}
                              td
                                span(:title="item.payment_gateway") {{ item.payment_gateway }}
                              td
                                span(:title="item.promotion_id") {{ item.promotion_id }}
                              td
                                span(:title="item.promotion_name") {{ item.promotion_name }}
                    div.col-sm-12.col-md-12.col-lg-12
                      b-form-group(:label="$t('ui.withdrawal')")
                        table.tablex(width="100%")
                          thead
                            tr
                              th(width="45%")
                                span(:title="$t('ui.date')") {{ $t("ui.date") }}
                              th(width="55%")
                                span(:title="$t('ui.withdrawal')") {{ $t("ui.withdrawal") }}
                          tbody
                            tr(v-if="withdrawalList.length == 0")
                              td(colspan="2").text-center
                                span {{ $t('message.no_data_available') }}
                            tr(v-for="(item, index) in withdrawalList")
                              td
                                span(:title="$moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss') }}
                              td
                                span(:title="$n(item.amount, 'currency')") {{ $n(item.amount, 'currency') }}
                    div.col-sm-12.col-md-12.col-lg-12
                      b-form-group(:label="$t('ui.login')")
                        table.tablex(width="100%")
                          thead
                            tr
                              th(width="15%")
                                span(:title="$t('ui.date')") {{ $t("ui.date") }}
                              th(width="35%")
                                span(:title="$t('ui.login_ip')") {{ $t("ui.login_ip") }}
                              th(width="50%")
                                span(:title="$t('ui.browser_agent')") {{ $t("ui.browser_agent") }}
                          tbody
                            tr(v-if="loginList.length == 0")
                              td(colspan="3").text-center
                                span {{ $t('message.no_data_available') }}
                            tr(v-for="(item, index) in loginList")
                              td
                                span(:title="$moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss') }}
                              td
                                span(:title="item.login_ip") {{ item.login_ip }}
                              td
                                span(:title="item.browser_agent") {{ item.browser_agent }}
                    div.col-sm-12.col-md-12.col-lg-12
                      b-form-group(:label="$t('ui.daily_statement')")
                        div.row.col-md-10.mb-2.text-uppercase.mt-2
                          div(width="70%").mr-3
                            DateRangePicker(:value="dateRangeStatement" @update="getDataStatement" ref="dateRangeStatement")
                          div(width="30%")
                            SubmitButton(
                              :loading="loading"
                              icon="fa fa-search"
                              :text="$t('ui.search')"
                              type="button"
                              @click="getStatement(true)"
                              variant="success"
                              size="sm"
                              )
                        div.row.mb-2
                          div.col-md-10
                            b-pagination.float-left(
                              size="sm"
                              hide-ellipsis
                              :total-rows="totalRowStatement"
                              :per-page="getPageSize"
                              v-model="currentPageStatement"
                              @input="changedPageStatement($event)").mb-1
                          div.col-md-2
                            b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                              b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSizeStatement")
                        .clusterize-scroll(style="min-height: 400px;")
                          table.tablex(style="width: 100%;")
                            thead
                              tr
                                th.sticky-position.sortable(width="10%" @click="sortOrder('working_date','statement')")
                                  span(:title="$t('ui.working_date')") {{ $t('ui.working_date') }}
                                  i(:class="changeSortKey('working_date','statement')")
                                th.sticky-position.text-right(width="11%")
                                  span(:title="$t('ui.opening_balance')") {{ $t('ui.opening_balance') }}
                                th.sticky-position.text-right(width="11%")
                                  span(:title="$t('ui.turnover')") {{ $t('ui.turnover') }}
                                th.sticky-position.text-right(width="11%")
                                  span(:title="$t('ui.valid_turnover')") {{ $t('ui.valid_turnover') }}
                                th.sticky-position.text-right(width="11%")
                                  span(:title="$t('ui.winlose')") {{ $t('ui.winlose') }}
                                th.sticky-position.text-right(width="11%")
                                  span(:title="$t('ui.deposit_amount')") {{ $t('ui.deposit_amount') }}
                                th.sticky-position.text-right(width="11%")
                                  span(:title="$t('ui.withdrawal_amount')") {{ $t("ui.withdrawal_amount") }}
                                th.sticky-position.text-right(width="11%")
                                  span(:title="$t('ui.bonus_amount')") {{ $t("ui.bonus_amount") }}
                                th.sticky-position.text-right(width="11%")
                                  span(:title="$t('ui.adjustment_amount')") {{ $t("ui.adjustment_amount") }}
                                th.sticky-position.text-right(width="11%")
                                  span(:title="$t('ui.referee_count')") {{ $t("ui.referee_count") }}
                                th.sticky-position.text-right(width="10%")
                                  span(:title="$t('ui.closing_balance')") {{ $t("ui.closing_balance") }}
                            tbody.clusterize-content
                              tr(v-if="statementList.length == 0")
                                td(colspan="11").text-center
                                  span {{ $t('message.no_data_available') }}
                              tr(v-for="(item, index) in statementList")
                                td
                                  span(:title="$moment(item.working_date).format('YYYY-MM-DD')") {{ $moment(item.working_date).format('YYYY-MM-DD') }}
                                td.text-right
                                  span.font-weight-bold(:class="$helpers.fontClassName(item.opening_balance)" :title="$n(item.opening_balance, 'currency')") {{ $n(item.opening_balance, 'currency') }}
                                td.text-right
                                  span.font-weight-bold(:class="$helpers.fontClassName(item.turnover)" :title="$n(item.turnover, 'currency')") {{ $n(item.turnover, 'currency') }}
                                td.text-right
                                  span.font-weight-bold(:class="$helpers.fontClassName(item.valid_turnover)" :title="$n(item.valid_turnover, 'currency')") {{ $n(item.valid_turnover, 'currency') }}
                                td.text-right
                                  span.font-weight-bold(v-if="item.winlose != 0 && showActionButton('platformwinlose')")
                                    b-link(href="javascript:void(0);" @click="redirectToWL(item)" :class="$helpers.fontClassName(item.winlose, true)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                                  span.font-weight-bold(v-else :class="$helpers.fontClassName(item.winlose)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                                td.text-right
                                  span.font-weight-bold(v-if="item.deposit_amount == 0" :class="$helpers.fontClassName(item.deposit_amount)" :title="$n(item.deposit_amount, 'currency')") {{ $n(item.deposit_amount, 'currency') }}
                                  span.font-weight-bold(v-if="item.deposit_amount != 0")
                                    b-link(href="javascript:void(0);" @click="redirectToTicketWalletTrans(item, 'DEPOSIT')" :class="$helpers.fontClassName(item.deposit_amount, true)" :title="$n(item.deposit_amount, 'currency')") {{ $n(item.deposit_amount, 'currency') }}
                                td.text-right
                                  span.font-weight-bold(v-if="item.withdrawal_amount == 0" :class="$helpers.fontClassName(item.withdrawal_amount * -1)" :title="$n(item.withdrawal_amount > 0 ? item.withdrawal_amount * -1 : item.withdrawal_amount, 'currency')") {{ $n(item.withdrawal_amount > 0 ? item.withdrawal_amount * -1 : item.withdrawal_amount, 'currency') }}
                                  span.font-weight-bold(v-if="item.withdrawal_amount != 0")
                                    b-link(href="javascript:void(0);" @click="redirectToTicketWalletTrans(item, 'WITHDRAWAL')" :class="$helpers.fontClassName(item.withdrawal_amount * -1)" :title="$n(item.withdrawal_amount > 0 ? item.withdrawal_amount * -1 : item.withdrawal_amount, 'currency')") {{ $n(item.withdrawal_amount > 0 ? item.withdrawal_amount * -1 : item.withdrawal_amount, 'currency') }}
                                td.text-right
                                  span.font-weight-bold(v-if="item.bonus_amount == 0" :class="$helpers.fontClassName(item.bonus_amount)" :title="$n(item.bonus_amount, 'currency')") {{ $n(item.bonus_amount, 'currency') }}
                                  span.font-weight-bold(v-if="item.bonus_amount != 0")
                                    b-link(href="javascript:void(0);" @click="redirectToBonus(item)" :class="$helpers.fontClassName(item.bonus_amount, true)" :title="$n(item.bonus_amount, 'currency')") {{ $n(item.bonus_amount, 'currency') }}
                                td.text-right
                                  span.font-weight-bold
                                    b-link(href="javascript:void(0);" @click="redirectToAdjustment(item)" :class="[item.adjustment_amount < 0 ? 'text-danger' : 'text-info']" :title="$n(item.adjustment_amount, 'currency')") {{ $n(item.adjustment_amount, 'currency') }}
                                td.text-right
                                  span.font-weight-bold(:title="$n(item.referee_count, 'integer')") {{ $n(item.referee_count, 'integer') }}
                                td.text-right
                                  span.font-weight-bold(:class="$helpers.fontClassName(item.closing_balance)" :title="$n(item.closing_balance, 'currency')") {{ $n(item.closing_balance, 'currency') }}
                              tr(v-if="showTotalStatement")
                                td.text-right(colspan="2")
                                  span {{ $t("ui.sub_total") }}
                                  br
                                  span {{ $t("ui.grand_total") }}
                                td.text-right
                                  span.font-weight-bold(:class="$helpers.fontClassName(subTotalTurnoverStatement)" :title="$n(subTotalTurnoverStatement, 'currency')") {{ $n(subTotalTurnoverStatement, 'currency') }}
                                  br
                                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalTurnoverStatement)" :title="$n(grandTotalTurnoverStatement, 'currency')") {{ $n(grandTotalTurnoverStatement, 'currency') }}
                                td.text-right
                                  span.font-weight-bold(:class="$helpers.fontClassName(subTotalValidTurnoverStatement)" :title="$n(subTotalValidTurnoverStatement, 'currency')") {{ $n(subTotalValidTurnoverStatement, 'currency') }}
                                  br
                                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalValidTurnoverStatement)" :title="$n(grandTotalValidTurnoverStatement, 'currency')") {{ $n(grandTotalValidTurnoverStatement, 'currency') }}
                                td.text-right
                                  span.font-weight-bold(:class="$helpers.fontClassName(subTotalWinLoseStatement)" :title="$n(subTotalWinLoseStatement, 'currency')") {{ $n(subTotalWinLoseStatement, 'currency') }}
                                  br
                                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWinLoseStatement)" :title="$n(grandTotalWinLoseStatement, 'currency')") {{ $n(grandTotalWinLoseStatement, 'currency') }}
                                td.text-right
                                  span.font-weight-bold(:class="$helpers.fontClassName(subTotalDepositAmountStatement)" :title="$n(subTotalDepositAmountStatement, 'currency')") {{ $n(subTotalDepositAmountStatement, 'currency') }}
                                  br
                                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalDepositAmountStatement)" :title="$n(grandTotalDepositAmountStatement, 'currency')") {{ $n(grandTotalDepositAmountStatement, 'currency') }}
                                td.text-right
                                  span.font-weight-bold(:class="[subTotalWithdrawalAmountStatement == 0 ? 'text-primary' : 'text-danger']" :title="$n(subTotalWithdrawalAmountStatement > 0 ? subTotalWithdrawalAmountStatement * -1 : subTotalWithdrawalAmountStatement, 'currency')") {{ $n(subTotalWithdrawalAmountStatement > 0 ? subTotalWithdrawalAmountStatement * -1 : subTotalWithdrawalAmountStatement, 'currency') }}
                                  br
                                  span.font-weight-bold(:class="[grandTotalWithdrawalAmountStatement == 0 ? 'text-primary' : 'text-danger']" :title="$n(grandTotalWithdrawalAmountStatement > 0 ? grandTotalWithdrawalAmountStatement * -1 : grandTotalWithdrawalAmountStatement, 'currency')") {{ $n(grandTotalWithdrawalAmountStatement > 0 ? grandTotalWithdrawalAmountStatement * -1 : grandTotalWithdrawalAmountStatement, 'currency') }}
                                td.text-right
                                  span.font-weight-bold(:class="$helpers.fontClassName(subTotalBonusAmountStatement)" :title="$n(subTotalBonusAmountStatement, 'currency')") {{ $n(subTotalBonusAmountStatement, 'currency') }}
                                  br
                                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalBonusAmountStatement)" :title="$n(grandTotalBonusAmountStatement, 'currency')") {{ $n(grandTotalBonusAmountStatement, 'currency') }}
                                td.text-right
                                  span.font-weight-bold(:class="$helpers.fontClassName(subTotalAdjustmentAmountStatement)" :title="$n(subTotalAdjustmentAmountStatement, 'currency')") {{ $n(subTotalAdjustmentAmountStatement, 'currency') }}
                                  br
                                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalAdjustmentAmountStatement)" :title="$n(grandTotalAdjustmentAmountStatement, 'currency')") {{ $n(grandTotalAdjustmentAmountStatement, 'currency') }}
                                td.text-right
                                  span.font-weight-bold(:class="$helpers.fontClassName(subTotalRefereeCountStatement)" :title="$n(subTotalRefereeCountStatement, 'integer')") {{ $n(subTotalRefereeCountStatement, 'integer') }}
                                  br
                                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalRefereeCountStatement)" :title="$n(grandTotalRefereeCountStatement, 'integer')") {{ $n(grandTotalRefereeCountStatement, 'integer') }}
                                td
            b-card.mb-1(no-body='')
              b-card-header.p-1(header-tag='header' role='tab')
                b-button(block='' v-b-toggle.accordion-2='' variant='secondary') {{ $t('ui.member_info') }}
              b-collapse#accordion-2( role='tabpanel')
                b-card-body
                  div.row
                    div.col-sm-4.col-md-4.col-lg-4
                      b-form-group
                        table.tablex(width="100%")
                          thead
                            tr
                              th(colspan="2")
                                span  {{ $tc("ui.members", 1) }}
                          tbody
                            tr
                              td
                                span {{ $t("ui.member_id") }}
                              td
                                span {{ member.account_id }}
                            tr
                              td
                                span {{ $t("ui.contact_phone") }}
                              td
                                span {{ member.contact_phone }}
                            //- tr
                            //-   td
                            //-     span {{ $t("ui.vip_name") }}
                            //-   td
                            //-     span {{ member.vip_name }}
                            tr
                              td
                                span {{ $t("ui.signup_ip") }}
                              td
                                span {{ member.signup_ip }}
                            tr
                              td
                                span {{ $t("ui.login_ip") }}
                              td
                                span {{ member.last_login_ip }}
                            tr
                              td
                                span {{ $t("ui.balance") }}
                              td
                                template(v-if="wallet != null")
                                  span(:title="$n(wallet.game_balance, 'currency')") {{ $n(wallet.game_balance, 'currency') }}
                                  span.font-weight-bold(:class="{'text-danger': wallet.outstanding_balance < 0  }" v-if="wallet.outstanding_balance != 0 && wallet.outstanding_balance != null && showActionButton('clearoutstanding') == true" :title="$n(wallet.outstanding_balance, 'currency')")
                                    b-link.clickable(href="javascript:void(0);" @click="onClearOutstanding(member)") ({{ $n(wallet.outstanding_balance, 'currency') }})
                                  span(:class="{'text-danger': wallet.outstanding_balance < 0  }" v-if="wallet.outstanding_balance != 0 && wallet.outstanding_balance != null && showActionButton('clearoutstanding') == false" :title="$n(wallet.outstanding_balance, 'currency')") ({{ $n(wallet.outstanding_balance, 'currency') }})
                                template(v-else)
                                  span 0
                            tr
                              td
                                span {{ $t("ui.referral_code") }}
                              td
                                span {{ member.referral_code }}
                            tr
                              td
                                span {{ $t("ui.upline") }}
                              td
                                span {{ member.referrer_id }}
                            tr
                              td
                                span {{ $t("ui.created_date") }}
                              td
                                span(:title="$moment(member.created_date).format('YYYY-MM-DD, HH:mm:ss')" v-if="member.created_date") {{ $moment(member.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
                            tr
                              td
                                span {{ $t("ui.verified_date") }}
                              td
                                span(:title="$moment(member.verified_date).format('YYYY-MM-DD, HH:mm:ss')" v-if="member.verified_date") {{ $moment(member.verified_date).format('YYYY-MM-DD, HH:mm:ss') }}
                            tr
                              td
                                span {{ $t("ui.downline") }}
                              td
                                span.font-weight-bold(v-if="member.referee_count_confirm != 0 && showActionButton('refereelist')")
                                  b-link(href="javascript:void(0);" @click="redirectToRL(member)" :title="$n(member.referee_count_confirm, 'integer')") {{ $n(member.referee_count_confirm, 'integer') }}
                                span.font-weight-bold(v-else :title="$n(member.referee_count_confirm, 'integer')") {{ $n(member.referee_count_confirm, 'integer') }}
                            tr
                              td
                                span {{ $t("ui.status") }}
                              td
                                span(v-if="member.status.toUpperCase() == 'FREEZE' || member.status.toUpperCase() == 'BLOCK'" :title="member.status") {{ member.status }}
                                select(@change="changedMemberStatus(member, $event)" :value="member.status" v-else)
                                  option(value="ACTIVE") {{ $t("ui.active") }}
                                  option(value="CLOSE") {{ $t("ui.close") }}
                                  option(value="SUSPEND") {{ $t("ui.suspend") }}
                            tr
                              td
                                span {{ $t("ui.affiliate") }}
                              td
                                span {{ member.affiliate_id }}
                            tr
                              td
                                span {{ $t("ui.remark") }}
                              td
                                span(style="white-space: initial;!important") {{ member.remark }}
                            //- tr
                            //-   td
                            //-     span {{ $t("ui.deposit_amount") }}
                            //-   td
                            //-     span {{ $n(member.deposit_amount, 'currency') }}
                            //- tr
                            //-   td
                            //-     span {{ $t("ui.withdrawal_amount") }}
                            //-   td
                            //-     span {{ $n(member.withdrawal_amount, 'currency') }}
                    div.col-sm-8.col-md-8.col-lg-8
                      div.row
                        div.col-md-6.mb-1
                          table.tablex(width="100%").mb-3
                            thead
                              tr
                                th(colspan="2")
                                  span  {{ $t("ui.promotion") }}
                            tbody
                              tr
                                td
                                  span {{ $t("ui.promo") }}
                                td
                                  span {{ promoID }}
                              tr
                                td
                                  span {{ $t("ui.promo_name") }}
                                td
                                  span {{ promoName }}
                              tr
                                td
                                  span {{ $t("ui.bonus_amount") }}
                                td
                                  span {{ $n(bonusAmount, 'currency') }}
                              tr
                                td
                                  span {{ $t("ui.created_date") }}
                                td
                                  span(v-if="promoDate") {{ $moment(promoDate).format('YYYY-MM-DD, HH:mm:ss') }}
                              tr
                                td
                                  span {{ $t("ui.criteria") }}
                                td
                                  span {{ promoCriteria }}
                              //- tr
                              //-   td
                              //-     span {{ $t("ui.progress") }}
                              //-   td
                              //-     span {{ promoAccumulate }}/{{ promoTarget }}
                          span.ml-1.font-weight-bold {{ promoID }} ({{ $n(promoAccumulate, 'currency') }}/{{ $n(promoTarget, 'currency') }})
                          b-progress(:max="promoTarget" height="1.5rem" show-progress animated style="border-style: solid;border-radius: 10px;")
                            b-progress-bar(v-if="promoAccumulate < promoTarget" :value='promoAccumulate' variant="success" :label='`${((promoAccumulate / promoTarget) * 100).toFixed(2)}%`')
                            b-progress-bar(v-else :value='promoAccumulate' variant="success" label='100.00%')
                        div.col-md-6.mb-1
                          div.row
                            div(width="30%" v-if="showActionButton('edit')").mr-3.mb-2
                              SubmitButton(
                                :loading="loading"
                                icon="fa fa-edit"
                                :text="$t('ui.edit')"
                                type="button"
                                @click="onEdit(member)"
                                variant="primary"
                                size="sm"
                                )
                            div(width="30%" v-if="showActionButton('resetpassword')").mr-3.mb-2
                              SubmitButton(
                                :loading="loading"
                                icon="fa fa-lock"
                                :text="$t('ui.reset_password')"
                                type="button"
                                @click="onResetPasswordMember(member)"
                                variant="warning"
                                size="sm"
                                )
                            div(width="30%" v-if="showActionButton('updatememberprofile')").mr-3.mb-2
                              SubmitButton(
                                :loading="loading"
                                icon="fa fa-user"
                                :text="$t('ui.update_member_profile')"
                                type="button"
                                @click="onUpdateMemberProfile(member)"
                                variant="success"
                                size="sm"
                                )
                            div(width="30%" v-if="showActionButton('updatememberbetlimit')").mr-3.mb-2
                              SubmitButton(
                                :loading="loading"
                                icon="fa fa-gamepad"
                                :text="$t('ui.update_member_bet_limit')"
                                type="button"
                                @click="onUpdateMemberBetLimit(member)"
                                variant="secondary"
                                size="sm"
                                )
                            div(width="30%" v-if="showActionButton('adjustbalance')").mr-3.mb-2
                              SubmitButton(
                                :loading="loading"
                                icon="fa fa-sliders-h"
                                :text="$t('ui.adjust_balance')"
                                type="button"
                                @click="onAdjust(member)"
                                variant="danger"
                                size="sm"
                                )
                            div(width="30%" v-if="showActionButton('addpromotion')").mr-3.mb-2
                              SubmitButton(
                                :loading="loading"
                                icon="fa fa-gift"
                                :text="$t('ui.add_promo')"
                                type="button"
                                @click="onPromoMemberAssign(member)"
                                variant="info"
                                size="sm"
                                )
                            div(width="30%" v-if="showActionButton('bonusissue')").mr-3.mb-2
                              SubmitButton(
                                :loading="loading"
                                icon="fa fa-money-bill-alt"
                                :text="$t('ui.bonus_issue')"
                                type="button"
                                @click="onBonusIssue(member)"
                                variant="primary"
                                size="sm"
                                )
                            div(width="30%" v-if="showActionButton('updatevip')").mr-3.mb-2
                              SubmitButton(
                                :loading="loading"
                                icon="fas fa-crown"
                                :text="$t('ui.update_vip')"
                                type="button"
                                @click="onUpdateVip(member)"
                                variant="warning"
                                size="sm"
                                )
                            div(width="30%" v-if="showActionButton('gettac')").mr-3.mb-2
                              SubmitButton(
                                :loading="loading"
                                icon="fas fa-mobile-alt"
                                :text="$t('ui.get_tac')"
                                type="button"
                                @click="onGetTac(member)"
                                variant="success"
                                size="sm"
                                )
                            div(width="30%" v-if="showActionButton('getbanktac')").mr-3.mb-2
                              SubmitButton(
                                :loading="loading"
                                icon="fas fa-building"
                                :text="$t('ui.get_bank_tac')"
                                type="button"
                                @click="onGetBankTac(member)"
                                variant="secondary"
                                size="sm"
                                )
                            div(width="30%" v-if="showActionButton('getinbox')").mr-3.mb-2
                              SubmitButton(
                                :loading="loading"
                                icon="fas fa-envelope"
                                :text="$t('ui.get_inbox')"
                                type="button"
                                @click="onGetInbox(member)"
                                variant="danger"
                                size="sm"
                                )
                            div(width="30%" v-if="showActionButton('getrebate')").mr-3.mb-2
                              SubmitButton(
                                :loading="loading"
                                icon="fas fa-piggy-bank"
                                :text="$t('ui.get_rebate')"
                                type="button"
                                @click="onGetRebate(member)"
                                variant="info"
                                size="sm"
                                )
                            div(width="30%" v-if="showActionButton('issuefreespin')").mr-3.mb-2
                              SubmitButton(
                                :loading="loading"
                                icon="fas fa-dice"
                                :text="$t('ui.issue_free_spin')"
                                type="button"
                                @click="onIssueFreeSpin(member)"
                                variant="primary"
                                size="sm"
                                )
                            div(width="30%" v-if="showActionButton('checkfreespin')").mr-3.mb-2
                              SubmitButton(
                                :loading="loading"
                                icon="fas fa-gamepad"
                                :text="$t('ui.check_free_spin')"
                                type="button"
                                @click="onCheckMemberFreeSpin(member)"
                                variant="warning"
                                size="sm"
                                )
                            div(width="30%" v-if="member.status.toUpperCase() == 'ACTIVE' && showActionButton('raisedepositticket')").mr-3.mb-2
                              SubmitButton(
                                :loading="loading"
                                icon="fas fa-list-alt"
                                :text="$t('ui.raise_deposit_ticket')"
                                type="button"
                                @click="onRaiseDepositTicket(member)"
                                variant="success"
                                size="sm"
                                )
                            div(width="30%" v-if="member.status.toUpperCase() == 'ACTIVE' && showActionButton('raisedepositticket')").mr-3.mb-2
                              SubmitButton(
                                :loading="loading"
                                icon="fas fa-list-alt"
                                :text="$t('ui.raise_deposit_ticket_gateway')"
                                type="button"
                                @click="onRaiseDepositTicketGateway(member)"
                                variant="secondary"
                                size="sm"
                                )
                            div(width="30%" v-if="showActionButton('freecredit')").mr-3.mb-2
                              SubmitButton(
                                :loading="loading"
                                icon="fa fa-credit-card"
                                :text="$t('ui.free_credit')"
                                type="button"
                                @click="onPromoSignupAssign(member)"
                                variant="danger"
                                size="sm"
                                )
                            div(width="30%" v-if="member.status.toUpperCase() == 'BLOCK' && showActionButton('unblock')").mr-3.mb-2
                              SubmitButton(
                                :loading="loading"
                                icon="fa fa-unlock"
                                :text="$t('ui.unblock')"
                                type="button"
                                @click="onUnblock(member)"
                                variant="info"
                                size="sm"
                                )
                      div.row
                        div.col-md-6.mb-1
                          table.tablex(width="100%").mb-3
                            thead
                              tr
                                th(colspan="2")
                                  span  {{ $t("ui.vip") }}
                            tbody
                              tr
                                td
                                  span {{ $t("ui.current_level") }}
                                td
                                  span {{ currentVip }}
                              tr
                                td
                                  span {{ $t("ui.next_level") }}
                                td
                                  span {{ nextVip }}
                              tr
                                td
                                  span {{ $t("ui.possible_next_level") }}
                                td
                                  span {{ possibleNextVip }}
                              tr
                                td
                                  span {{ $t("ui.cycle") }}
                                td
                                  span {{ lastCycle ? $moment(lastCycle).format('YYYY-MM-DD') : null }} - {{ nextCycle ? $moment(nextCycle).format('YYYY-MM-DD') : null }}
                              //- tr(v-if="rewardTypeNext == null")
                              //-   td
                              //-     span {{ $t("ui.reward") }}
                              //-   td
                              //-     span &nbsp;
                              //- tr(v-if="rewardTypeNext == 'CASH'")
                              //-   td
                              //-     span {{ $t("ui.reward") }}
                              //-   td
                              //-     span {{ $n(cashNext, 'currency') }}
                              //- tr(v-if="rewardTypeNext == 'CS'")
                              //-   td
                              //-     span {{ $t("ui.reward") }}
                              //-   td
                              //-     span {{ $t("ui.cs") }} ({{ spNext }})
                              //- tr(v-if="rewardTypeNext == 'CS'")
                              //-   td
                              //-     span {{ $t("ui.social_platform") }}
                              //-   td
                              //-     span {{ spNext }}
                              //- tr
                              //-   td
                              //-     span {{ $t("ui.progress") }} 
                              //-   td
                              //-     span {{ vipDepositAcc }}/{{ vipDepositTarget }}
                          template(v-if="vipDepositTarget > 0")
                            span.ml-1.font-weight-bold {{ $t("ui.deposit") }} ({{ $n(vipDepositAcc, 'currency') }}/{{ $n(vipDepositTarget, 'currency') }})
                            b-progress(:max="vipDepositTarget" height="1.5rem" show-progress animated style="border-style: solid;border-radius: 10px;")
                              b-progress-bar(v-if="vipDepositAcc < vipDepositTarget" :value='vipDepositAcc' variant="info" :label='`${((vipDepositAcc / vipDepositTarget) * 100).toFixed(2)}%`')
                              b-progress-bar(v-else :value='vipDepositTarget' variant="success" label='100.00%')
                          template(v-if="vipTurnoverTarget > 0")
                            span.ml-1.font-weight-bold {{ $t("ui.turnover") }} ({{ $n(vipTurnoverAcc, 'currency') }}/{{ $n(vipTurnoverTarget, 'currency') }})
                            b-progress(:max="vipTurnoverTarget" height="1.5rem" show-progress animated style="border-style: solid;border-radius: 10px;")
                              b-progress-bar(v-if="vipTurnoverAcc < vipTurnoverTarget" :value='vipTurnoverAcc' variant="warning" :label='`${((vipTurnoverAcc / vipTurnoverTarget) * 100).toFixed(2)}%`')
                              b-progress-bar(v-else :value='vipTurnoverTarget' variant="success" label='100.00%')
                        div.col-md-6.mb-1
                          table.tablex(width="100%").mb-3
                            thead
                              tr
                                th
                                  span  {{ $t("ui.label") }}
                                th.text-right
                                  span
                                    a.fa.fa-edit.text-primary(href="javascript:void(0)" @click="onUpsertLabel(member)" :title="$t('ui.edit')")
                            tbody
                              tr
                                td(colspan="2")
                                  template(v-if="memberLabel")
                                    span.badge.badge-info.align-middle(v-for="obj in memberLabel.split(',').sort()" style="width: auto;") {{ obj }}
                  div.row
                    div.col-sm-12.col-md-12.col-lg-12
                      b-form-group(:label="$tc('ui.banks', 2)")
                        table.tablex(width="100%")
                          thead
                            tr
                              th(width="5%")
                                span #
                              th(width="15%")
                                span(:title="$t('ui.bank_id')") {{ $t("ui.bank_id") }}
                              th(width="20%")
                                span(:title="$t('ui.bank_acc_no')") {{ $t("ui.bank_acc_no") }}
                              th(width="25%")
                                span(:title="$t('ui.bank_acc_holder')") {{ $t("ui.bank_acc_holder") }}
                              th.text-center(width="10%")
                                span(:title="$t('ui.status')") {{ $t("ui.status") }}
                              th(width="10%")
                                span(:title="$t('ui.category')") {{ $t("ui.category") }}
                              th(width="15%")
                                span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                          tbody
                            tr(v-if="bankList.length == 0")
                              td(colspan="7").text-center
                                span {{ $t('message.no_data_available') }}
                            tr(v-for="(item, index) in bankList")
                              td
                                span(:title="index + 1") {{ index + 1 }}
                              td
                                span(:title="item.bank_id") {{ item.bank_id }}
                              td
                                span(:title="item.bank_acc_no") {{ item.bank_acc_no }}
                              td
                                span(:title="item.bank_acc_holder") {{ item.bank_acc_holder }}
                              td.text-center
                                div.d-flex.justify-content-center.align-items-center
                                  label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                                    input.switch-input(type="checkbox" v-model="item.status" @change="changedBankMbmStatus(item, $event)")
                                    span.switch-slider(:data-checked='on' :data-unchecked='off')
                              td
                                span(:title="item.category") {{ item.category }}
                              td
                                span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
            b-card.mb-1(no-body='')
              b-card-header.p-1(header-tag='header' role='tab')
                b-button(block='' v-b-toggle.accordion-3='' variant='success') {{ $t('ui.game_result') }}
              b-collapse#accordion-3( role='tabpanel')
                b-card-body
                  b-tabs(small card)
                    b-tab(title-link-class="small-link" title-item-class="small-item" v-if="showActionButton('gameresultslots')")
                      template(slot="title")
                        span(style="padding: 1px; line-height: 16px;") {{ $t("ui.slots") }}
                      div.d-flex.flex-wrap(style="min-height: 400px;")
                        div.clusterize
                          div.row.mb-2.text-uppercase
                            div.col-md-2.mb-1
                              b-input-group(size="sm")
                                b-input-group-text(slot="prepend")
                                  i.fa.fa-gamepad
                                ProviderLookup(
                                  size="sm"
                                  type="array"
                                  v-model="providerSlots"
                                  :disabled="loading"
                                  @input="getGameResultSlots(true)"
                                )
                            div.row.col-md-8.mb-1
                              div(width="70%").mr-3
                                DateTimeRangePicker(:value="dateRangeSlots" @update="getDataSlots" ref="dateRangeSlots")
                              div(width="30%")
                                SubmitButton(
                                  :loading="loading"
                                  icon="fa fa-search"
                                  :text="$t('ui.search')"
                                  type="button"
                                  @click="getGameResultSlots(true)"
                                  variant="success"
                                  size="sm"
                                  )
                          div.row.mb-2
                            div.col-md-10
                              b-pagination.float-left(
                                size="sm"
                                hide-ellipsis
                                :total-rows="totalRowSlots"
                                :per-page="getPageSize"
                                v-model="currentPageSlots"
                                @input="changedPageSlots($event)").mb-1
                            div.col-md-2
                              b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                                b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSizeSlots")
                          .clusterize-scroll
                            table.tablex(style="width: 100%;")
                              thead
                                tr
                                  th.sticky-position(width="3%")
                                    span #
                                  th.sticky-position(width="17%")
                                    span(:title="$t('ui.result_id')") {{ $t('ui.result_id') }}
                                  th.sticky-position.text-right.sortable(width="12%" @click="sortOrder('bet_time', 'slots')")
                                    span(:title="$t('ui.bet_time')") {{ $t('ui.bet_time') }}
                                    i(:class="changeSortKey('bet_time', 'slots')")
                                  th.sticky-position.text-right.sortable(width="12%" @click="sortOrder('turnover', 'slots')")
                                    span(:title="$t('ui.turnover')") {{ $t('ui.turnover') }}
                                    i(:class="changeSortKey('turnover', 'slots')")
                                  th.sticky-position.text-right.sortable(width="12%" @click="sortOrder('valid_turnover', 'slots')")
                                    span(:title="$t('ui.valid_turnover')") {{ $t('ui.valid_turnover') }}
                                    i(:class="changeSortKey('valid_turnover', 'slots')")
                                  th.sticky-position.text-right.sortable(width="12%" @click="sortOrder('payout', 'slots')")
                                    span(:title="$t('ui.payout')") {{ $t('ui.payout') }}
                                    i(:class="changeSortKey('payout', 'slots')")
                                  th.sticky-position.text-right.sortable(width="12%" @click="sortOrder('winlose', 'slots')")
                                    span(:title="$t('ui.winlose')") {{ $t('ui.winlose') }}
                                    i(:class="changeSortKey('winlose', 'slots')")
                                  th.sticky-position.text-right(width="9%")
                                    span(:title="$t('ui.game_type')") {{ $t("ui.game_type") }}
                                  th.sticky-position.text-right(width="11%")
                                    span(:title="$t('ui.game_name')") {{ $t("ui.game_name") }}
                              tbody.clusterize-content
                                tr(v-if="slotsList.length == 0")
                                  td(colspan="9").text-center
                                    span {{ $t('message.no_data_available') }}
                                tr(v-for="(item, index) in slotsList")
                                  td
                                    span(:title="((currentPageSlots - 1) * getPageSize + index + 1)") {{ ((currentPageSlots - 1) * getPageSize + index + 1) }}
                                  td
                                    span.font-weight-bold.text-info(:title="item.result_id" v-if="resultDetailProvider.includes(item.provider_code)")
                                      b-link.text-info(href="javascript:void(0);" @click="getResultDetail(item)" :title="item.result_id") {{ item.result_id }}
                                    span(v-else :title="item.result_id") {{ item.result_id }}
                                  td.text-right
                                    span(:title="$moment(item.bet_time).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.bet_time).format('YYYY-MM-DD, HH:mm:ss') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(item.turnover)" :title="$n(item.turnover, 'currency')") {{ $n(item.turnover, 'currency') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(item.valid_turnover)" :title="$n(item.valid_turnover, 'currency')") {{ $n(item.valid_turnover, 'currency') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(item.payout)" :title="$n(item.payout, 'currency')") {{ $n(item.payout, 'currency') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(item.winlose)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                                  td.text-right
                                    span(:title="item.game_type") {{ item.game_type }}
                                  td.text-right
                                    span(:title="item.game_name") {{ item.game_name }}
                                tr(v-if="showTotalSlots")
                                  td.text-right(colspan="3")
                                    span {{ $t("ui.sub_total") }}
                                    br
                                    span {{ $t("ui.grand_total") }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(subTotalTurnoverSlots)" :title="$n(subTotalTurnoverSlots, 'currency')") {{ $n(subTotalTurnoverSlots, 'currency') }}
                                    br
                                    span.font-weight-bold(:class="$helpers.fontClassName(grandTotalTurnoverSlots)" :title="$n(grandTotalTurnoverSlots, 'currency')") {{ $n(grandTotalTurnoverSlots, 'currency') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(subTotalValidTurnoverSlots)" :title="$n(subTotalValidTurnoverSlots, 'currency')") {{ $n(subTotalValidTurnoverSlots, 'currency') }}
                                    br
                                    span.font-weight-bold(:class="$helpers.fontClassName(grandTotalValidTurnoverSlots)" :title="$n(grandTotalValidTurnoverSlots, 'currency')") {{ $n(grandTotalValidTurnoverSlots, 'currency') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(subTotalPayoutSlots)" :title="$n(subTotalPayoutSlots, 'currency')") {{ $n(subTotalPayoutSlots, 'currency') }}
                                    br
                                    span.font-weight-bold(:class="$helpers.fontClassName(grandTotalPayoutSlots)" :title="$n(grandTotalPayoutSlots, 'currency')") {{ $n(grandTotalPayoutSlots, 'currency') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(subTotalWinLoseSlots)" :title="$n(subTotalWinLoseSlots, 'currency')") {{ $n(subTotalWinLoseSlots, 'currency') }}
                                    br
                                    span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWinLoseSlots)" :title="$n(grandTotalWinLoseSlots, 'currency')") {{ $n(grandTotalWinLoseSlots, 'currency') }}
                                  td
                                  td
                                  //- td
                    b-tab(title-link-class="small-link" title-item-class="small-item" v-if="showActionButton('gameresultlivecasino')")
                      template(slot="title")
                        span(style="padding: 1px; line-height: 16px;") {{ $t("ui.livecasino") }}
                      div.d-flex.flex-wrap(style="min-height: 400px;")
                        div.clusterize
                          div.row.mb-2.text-uppercase
                            div.col-md-2.mb-1
                              b-input-group(size="sm")
                                b-input-group-text(slot="prepend")
                                  i.fa.fa-gamepad
                                ProviderLookup(
                                  size="sm"
                                  type="array"
                                  v-model="providerLivecasino"
                                  :disabled="loading"
                                  @input="getGameResultLivecasino(true)"
                                )
                            div.col-md-2.mb-1
                              b-input-group(size="sm")
                                b-input-group-text(slot="prepend")
                                  span {{ $t('ui.table_id') }}
                                DebounceInput(required autofocus type="text" v-model="tableIdLivecasino" @enter="getGameResultLivecasino(true)")
                            div.row.col-md-6.mb-1
                              div(width="70%").mr-3
                                DateTimeRangePicker(:value="dateRangeLivecasino" @update="getDataLivecasino" ref="dateRangeLivecasino")
                              div(width="30%")
                                SubmitButton(
                                  :loading="loading"
                                  icon="fa fa-search"
                                  :text="$t('ui.search')"
                                  type="button"
                                  @click="getGameResultLivecasino(true)"
                                  variant="success"
                                  size="sm"
                                  )
                          div.row.mb-2
                            div.col-md-10
                              b-pagination.float-left(
                                size="sm"
                                hide-ellipsis
                                :total-rows="totalRowLivecasino"
                                :per-page="getPageSize"
                                v-model="currentPageLivecasino"
                                @input="changedPageLivecasino($event)").mb-1
                            div.col-md-2
                              b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                                b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSizeLivecasino")
                          .clusterize-scroll
                            table.tablex(style="width: 100%;")
                              thead
                                tr
                                  th.sticky-position(width="3%")
                                    span #
                                  th.sticky-position(width="17%")
                                    span(:title="$t('ui.result_id')") {{ $t('ui.result_id') }}
                                  th.sticky-position.text-right.sortable(width="12%" @click="sortOrder('bet_time', 'livecasino')")
                                    span(:title="$t('ui.bet_time')") {{ $t('ui.bet_time') }}
                                    i(:class="changeSortKey('bet_time', 'livecasino')")
                                  th.sticky-position.text-right.sortable(width="12%" @click="sortOrder('turnover', 'livecasino')")
                                    span(:title="$t('ui.turnover')") {{ $t('ui.turnover') }}
                                    i(:class="changeSortKey('turnover', 'livecasino')")
                                  th.sticky-position.text-right.sortable(width="12%" @click="sortOrder('valid_turnover', 'livecasino')")
                                    span(:title="$t('ui.valid_turnover')") {{ $t('ui.valid_turnover') }}
                                    i(:class="changeSortKey('valid_turnover', 'livecasino')")
                                  th.sticky-position.text-right.sortable(width="12%" @click="sortOrder('payout', 'livecasino')")
                                    span(:title="$t('ui.payout')") {{ $t('ui.payout') }}
                                    i(:class="changeSortKey('payout', 'livecasino')")
                                  th.sticky-position.text-right.sortable(width="12%" @click="sortOrder('winlose', 'livecasino')")
                                    span(:title="$t('ui.winlose')") {{ $t('ui.winlose') }}
                                    i(:class="changeSortKey('winlose', 'livecasino')")
                                  th.sticky-position.text-right(width="9%")
                                    span(:title="$t('ui.game_type')") {{ $t("ui.game_type") }}
                                  th.sticky-position.text-right(width="11%")
                                    span(:title="$t('ui.game_name')") {{ $t("ui.game_name") }}
                                  th.sticky-position.text-right(width="11%")
                                    span(:title="$t('ui.table_id')") {{ $t("ui.table_id") }}
                              tbody.clusterize-content
                                tr(v-if="livecasinoList.length == 0")
                                  td(colspan="10").text-center
                                    span {{ $t('message.no_data_available') }}
                                tr(v-for="(item, index) in livecasinoList")
                                  td
                                    span(:title="((currentPageLivecasino - 1) * getPageSize + index + 1)") {{ ((currentPageLivecasino - 1) * getPageSize + index + 1) }}
                                  td
                                    span.font-weight-bold.text-info(:title="item.result_id" v-if="resultDetailProvider.includes(item.provider_code)")
                                      b-link.text-info(href="javascript:void(0);" @click="getResultDetail(item)" :title="item.result_id") {{ item.result_id }}
                                    span(v-else :title="item.result_id") {{ item.result_id }}
                                  td.text-right
                                    span(:title="$moment(item.bet_time).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.bet_time).format('YYYY-MM-DD, HH:mm:ss') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(item.turnover)" :title="$n(item.turnover, 'currency')") {{ $n(item.turnover, 'currency') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(item.valid_turnover)" :title="$n(item.valid_turnover, 'currency')") {{ $n(item.valid_turnover, 'currency') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(item.payout)" :title="$n(item.payout, 'currency')") {{ $n(item.payout, 'currency') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(item.winlose)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                                  td.text-right
                                    span(:title="item.game_type") {{ item.game_type }}
                                  td.text-right
                                    span(:title="item.game_name") {{ item.game_name }}
                                  td.text-right
                                    span(:title="item.table_id") {{ item.table_id }}
                                tr(v-if="showTotalLivecasino")
                                  td.text-right(colspan="3")
                                    span {{ $t("ui.sub_total") }}
                                    br
                                    span {{ $t("ui.grand_total") }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(subTotalTurnoverLivecasino)" :title="$n(subTotalTurnoverLivecasino, 'currency')") {{ $n(subTotalTurnoverLivecasino, 'currency') }}
                                    br
                                    span.font-weight-bold(:class="$helpers.fontClassName(grandTotalTurnoverLivecasino)" :title="$n(grandTotalTurnoverLivecasino, 'currency')") {{ $n(grandTotalTurnoverLivecasino, 'currency') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(subTotalValidTurnoverLivecasino)" :title="$n(subTotalValidTurnoverLivecasino, 'currency')") {{ $n(subTotalValidTurnoverLivecasino, 'currency') }}
                                    br
                                    span.font-weight-bold(:class="$helpers.fontClassName(grandTotalValidTurnoverLivecasino)" :title="$n(grandTotalValidTurnoverLivecasino, 'currency')") {{ $n(grandTotalValidTurnoverLivecasino, 'currency') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(subTotalPayoutLivecasino)" :title="$n(subTotalPayoutLivecasino, 'currency')") {{ $n(subTotalPayoutLivecasino, 'currency') }}
                                    br
                                    span.font-weight-bold(:class="$helpers.fontClassName(grandTotalPayoutLivecasino)" :title="$n(grandTotalPayoutLivecasino, 'currency')") {{ $n(grandTotalPayoutLivecasino, 'currency') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(subTotalWinLoseLivecasino)" :title="$n(subTotalWinLoseLivecasino, 'currency')") {{ $n(subTotalWinLoseLivecasino, 'currency') }}
                                    br
                                    span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWinLoseLivecasino)" :title="$n(grandTotalWinLoseLivecasino, 'currency')") {{ $n(grandTotalWinLoseLivecasino, 'currency') }}
                                  td
                                  td
                                  td
                                  //- td
                    b-tab(title-link-class="small-link" title-item-class="small-item" v-if="showActionButton('gameresultrebate')")
                      template(slot="title")
                        span(style="padding: 1px; line-height: 16px;") {{ $t("ui.rebate") }}
                      div.d-flex.flex-wrap(style="min-height: 400px;")
                        div.clusterize
                          div.row.mb-2.text-uppercase
                            div.col-md-2.mb-1
                              b-input-group(size="sm")
                                b-input-group-text(slot="prepend")
                                  span {{ $t('ui.type') }}
                                b-form-select(v-model="rebateType" @change="getGameResultRebate(true)")
                                  option(value="") {{ $t('ui.all') }}
                                  option(value="DOWNLINE") {{ $t('ui.downline') }}
                                  option(value="SELF") {{ $t("ui.self") }}
                            div.row.col-md-10.mb-2.text-uppercase
                              div(width="70%").mr-3
                                DateRangePicker(:value="dateRangeRebate" @update="getDataRebate" ref="dateRangeRebate")
                              div(width="30%")
                                SubmitButton(
                                  :loading="loading"
                                  icon="fa fa-search"
                                  :text="$t('ui.search')"
                                  type="button"
                                  @click="getGameResultRebate(true)"
                                  variant="success"
                                  size="sm"
                                  )
                          div.row.mb-2
                            div.col-md-10
                              b-pagination.float-left(
                                size="sm"
                                hide-ellipsis
                                :total-rows="totalRowRebate"
                                :per-page="getPageSize"
                                v-model="currentPageRebate"
                                @input="changedPageRebate($event)").mb-1
                            div.col-md-2
                              b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                                b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSizeRebate")
                          .clusterize-scroll
                            table.tablex(style="width: 100%;")
                              thead
                                tr
                                  th.sticky-position(width="3%")
                                    span #
                                  th.sticky-position(width="17%")
                                    span(:title="$t('ui.result_id')") {{ $t('ui.result_id') }}
                                  th.sticky-position.text-right.sortable(width="12%" @click="sortOrder('bet_time', 'rebate')")
                                    span(:title="$t('ui.bet_time')") {{ $t('ui.bet_time') }}
                                    i(:class="changeSortKey('bet_time', 'rebate')")
                                  th.sticky-position.text-right.sortable(width="12%" @click="sortOrder('turnover', 'rebate')")
                                    span(:title="$t('ui.turnover')") {{ $t('ui.turnover') }}
                                    i(:class="changeSortKey('turnover', 'rebate')")
                                  th.sticky-position.text-right.sortable(width="12%" @click="sortOrder('valid_turnover', 'rebate')")
                                    span(:title="$t('ui.valid_turnover')") {{ $t('ui.valid_turnover') }}
                                    i(:class="changeSortKey('valid_turnover', 'rebate')")
                                  th.sticky-position.text-right.sortable(width="12%" @click="sortOrder('payout', 'rebate')")
                                    span(:title="$t('ui.payout')") {{ $t('ui.payout') }}
                                    i(:class="changeSortKey('payout', 'rebate')")
                                  th.sticky-position.text-right.sortable(width="12%" @click="sortOrder('winlose', 'rebate')")
                                    span(:title="$t('ui.winlose')") {{ $t('ui.winlose') }}
                                    i(:class="changeSortKey('winlose', 'rebate')")
                                  th.sticky-position.text-right(width="9%")
                                    span(:title="$t('ui.game_type')") {{ $t("ui.game_type") }}
                                  th.sticky-position.text-right(width="11%")
                                    span(:title="$t('ui.game_name')") {{ $t("ui.game_name") }}
                              tbody.clusterize-content
                                tr(v-if="rebateList.length == 0")
                                  td(colspan="9").text-center
                                    span {{ $t('message.no_data_available') }}
                                tr(v-for="(item, index) in rebateList")
                                  td
                                    span(:title="((currentPageRebate - 1) * getPageSize + index + 1)") {{ ((currentPageRebate - 1) * getPageSize + index + 1) }}
                                  td
                                    span(:title="item.result_id") {{ item.result_id }}
                                  td.text-right
                                    span(:title="$moment(item.bet_time).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.bet_time).format('YYYY-MM-DD, HH:mm:ss') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(item.turnover)" :title="$n(item.turnover, 'currency')") {{ $n(item.turnover, 'currency') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(item.valid_turnover)" :title="$n(item.valid_turnover, 'currency')") {{ $n(item.valid_turnover, 'currency') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(item.payout)" :title="$n(item.payout, 'currency')") {{ $n(item.payout, 'currency') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(item.winlose)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                                  td.text-right
                                    span(:title="item.game_type") {{ item.game_type }}
                                  td.text-right
                                    span(:title="item.game_name") {{ item.game_name }}
                                tr(v-if="showTotalRebate")
                                  td.text-right(colspan="3")
                                    span {{ $t("ui.sub_total") }}
                                    br
                                    span {{ $t("ui.grand_total") }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(subTotalTurnoverRebate)" :title="$n(subTotalTurnoverRebate, 'currency')") {{ $n(subTotalTurnoverRebate, 'currency') }}
                                    br
                                    span.font-weight-bold(:class="$helpers.fontClassName(grandTotalTurnoverRebate)" :title="$n(grandTotalTurnoverRebate, 'currency')") {{ $n(grandTotalTurnoverRebate, 'currency') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(subTotalValidTurnoverRebate)" :title="$n(subTotalValidTurnoverRebate, 'currency')") {{ $n(subTotalValidTurnoverRebate, 'currency') }}
                                    br
                                    span.font-weight-bold(:class="$helpers.fontClassName(grandTotalValidTurnoverRebate)" :title="$n(grandTotalValidTurnoverRebate, 'currency')") {{ $n(grandTotalValidTurnoverRebate, 'currency') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(subTotalPayoutRebate)" :title="$n(subTotalPayoutRebate, 'currency')") {{ $n(subTotalPayoutRebate, 'currency') }}
                                    br
                                    span.font-weight-bold(:class="$helpers.fontClassName(grandTotalPayoutRebate)" :title="$n(grandTotalPayoutRebate, 'currency')") {{ $n(grandTotalPayoutRebate, 'currency') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(subTotalWinLoseRebate)" :title="$n(subTotalWinLoseRebate, 'currency')") {{ $n(subTotalWinLoseRebate, 'currency') }}
                                    br
                                    span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWinLoseRebate)" :title="$n(grandTotalWinLoseRebate, 'currency')") {{ $n(grandTotalWinLoseRebate, 'currency') }}
                                  td
                                  td
                                  //- td
                    b-tab(title-link-class="small-link" title-item-class="small-item" v-if="showActionButton('gameresultsportsbook')")
                      template(slot="title")
                        span(style="padding: 1px; line-height: 16px;") {{ $t("ui.sportsbook") }}
                      div.d-flex.flex-wrap(style="min-height: 400px;")
                        div.clusterize
                          div.row.col-md-10.mb-2.text-uppercase
                            div(width="70%").mr-3
                              DateRangePicker(:value="dateRangeSportsbook" @update="getDataSportsbook" ref="dateRangeSportsbook")
                            div(width="30%")
                              SubmitButton(
                                :loading="loading"
                                icon="fa fa-search"
                                :text="$t('ui.search')"
                                type="button"
                                @click="getGameResultSportsbook(true)"
                                variant="success"
                                size="sm"
                                )
                          div.row.mb-2
                            div.col-md-10
                              b-pagination.float-left(
                                size="sm"
                                hide-ellipsis
                                :total-rows="totalRowSportsbook"
                                :per-page="getPageSize"
                                v-model="currentPageSportsbook"
                                @input="changedPageSportsbook($event)").mb-1
                            div.col-md-2
                              b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                                b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSizeSportsbook")
                          .clusterize-scroll
                            table.tablex(style="width: 100%;")
                              thead
                                tr
                                  th.sticky-position(width="3%")
                                    span #
                                  th.sticky-position.sortable(width="12%" @click="sortOrder('bet_time', 'sportsbook')")
                                    span(:title="$t('ui.date_time')") {{ $t('ui.date_time') }}
                                    i(:class="changeSortKey('bet_time', 'sportsbook')")
                                  th.sticky-position(width="10%")
                                    span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                                  th.sticky-position.sortable(width="10%")
                                    span(:title="$t('ui.sports_game')") {{ $t('ui.sports_game') }}
                                  th.sticky-position.sortable(width="15%")
                                    span(:title="$t('ui.event')") {{ $t('ui.event') }}
                                  th.sticky-position.sortable(width="10%")
                                    span(:title="$t('ui.detail')") {{ $t('ui.detail') }}
                                  th.sticky-position.text-right.sortable(width="10%" @click="sortOrder('turnover', 'sportsbook')")
                                    span(:title="$t('ui.turnover')") {{ $t('ui.turnover') }}
                                    i(:class="changeSortKey('turnover', 'sportsbook')")
                                  th.sticky-position.text-right.sortable(width="10%" @click="sortOrder('valid_turnover', 'sportsbook')")
                                    span(:title="$t('ui.valid_turnover')") {{ $t('ui.valid_turnover') }}
                                    i(:class="changeSortKey('valid_turnover', 'sportsbook')")
                                  th.sticky-position.text-right.sortable(width="10%" @click="sortOrder('payout', 'sportsbook')")
                                    span(:title="$t('ui.payout')") {{ $t('ui.payout') }}
                                    i(:class="changeSortKey('payout', 'sportsbook')")
                                  th.sticky-position.text-right.sortable(width="10%" @click="sortOrder('winlose', 'sportsbook')")
                                    span(:title="$t('ui.winlose')") {{ $t('ui.winlose') }}
                                    i(:class="changeSortKey('winlose', 'sportsbook')")
                              tbody.clusterize-content
                                tr(v-if="sportsbookList.length == 0")
                                  td(colspan="10").text-center
                                    span {{ $t('message.no_data_available') }}
                                template(v-for="(item, index) in sportsbookList")
                                  tr
                                    td
                                      span(:title="((currentPageSportsbook - 1) * getPageSize + index + 1)") {{ ((currentPageSportsbook - 1) * getPageSize + index + 1) }}
                                    td
                                      span(:title="$moment(item.bet_time).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.bet_time).format('YYYY-MM-DD, HH:mm:ss') }}
                                      br
                                      span.font-weight-bold(:title="item.result_id") {{ item.result_id }}
                                      br
                                      span(:title="item.ip") {{ item.ip }}
                                    td
                                      span(:title="item.member_id") {{ item.member_id }}
                                    td
                                      span(:title="item.sports_category") {{ item.sports_category }}
                                      br
                                      span(:title="item.game_type_name") {{ item.game_type_name }}
                                    td
                                      template(v-if="item.bet_type != 'PARLAY'")
                                        span.font-weight-bold(:title="item.league_name") {{ item.league_name }}
                                        br
                                        span.text-success(:title="item.home_team_name") {{ item.home_team_name  }}
                                        span vs
                                        span.text-danger(:title="item.away_team_name") {{ item.away_team_name }}
                                        br
                                        span.text-info(:title="$moment(item.match_time).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.match_time).format('YYYY-MM-DD, HH:mm:ss') }}
                                        span.text-primary(:title="'(' + item.home_score + ' - ' + item.away_score + ')'") {{ '(' + item.home_score + ' - ' + item.away_score + ')' }}
                                      template(v-else)
                                        span.font-weight-bold(:title="$t('ui.mix_parlay')") {{ $t("ui.mix_parlay") }}
                                        br
                                        span(:title="item.odds_display_bet") {{ item.odds_display_bet }}
                                    td
                                      span(:title="item.bet_type") {{ item.bet_type }}
                                      br
                                      span(:title="item.bet_hand") {{ item.bet_hand }}
                                      br
                                      span(:title="item.odds_display + ' ' + getOddsType(item.odds_type)") {{ item.odds_display + ' ' + getOddsType(item.odds_type) }}
                                    td.text-right
                                      span.font-weight-bold(:class="$helpers.fontClassName(item.turnover)" :title="$n(item.turnover, 'currency')") {{ $n(item.turnover, 'currency') }}
                                    td.text-right
                                      span.font-weight-bold(:class="$helpers.fontClassName(item.valid_turnover)" :title="$n(item.valid_turnover, 'currency')") {{ $n(item.valid_turnover, 'currency') }}
                                    td.text-right
                                      span.font-weight-bold(:class="$helpers.fontClassName(item.payout)" :title="$n(item.payout, 'currency')") {{ $n(item.payout, 'currency') }}
                                    td.text-right
                                      span.font-weight-bold(:class="$helpers.fontClassName(item.winlose)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                                    td.text-center
                                      i.fa.ml-1(size="sm" @click="onOffDetail(item)" :class="currId == item.result_id ? 'fa-eye-slash text-danger' : 'fa-eye text-success'" style="cursor: pointer;")
                                tr(v-if="showTotalSportsbook")
                                  td.text-right(colspan="6")
                                    span {{ $t("ui.sub_total") }}
                                    br
                                    span {{ $t("ui.grand_total") }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(subTotalTurnoverSportsbook)" :title="$n(subTotalTurnoverSportsbook, 'currency')") {{ $n(subTotalTurnoverSportsbook, 'currency') }}
                                    br
                                    span.font-weight-bold(:class="$helpers.fontClassName(grandTotalTurnoverSportsbook)" :title="$n(grandTotalTurnoverSportsbook, 'currency')") {{ $n(grandTotalTurnoverSportsbook, 'currency') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(subTotalValidTurnoverSportsbook)" :title="$n(subTotalValidTurnoverSportsbook, 'currency')") {{ $n(subTotalValidTurnoverSportsbook, 'currency') }}
                                    br
                                    span.font-weight-bold(:class="$helpers.fontClassName(grandTotalValidTurnoverSportsbook)" :title="$n(grandTotalValidTurnoverSportsbook, 'currency')") {{ $n(grandTotalValidTurnoverSportsbook, 'currency') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(subTotalPayoutSportsbook)" :title="$n(subTotalPayoutSportsbook, 'currency')") {{ $n(subTotalPayoutSportsbook, 'currency') }}
                                    br
                                    span.font-weight-bold(:class="$helpers.fontClassName(grandTotalPayoutSportsbook)" :title="$n(grandTotalPayoutSportsbook, 'currency')") {{ $n(grandTotalPayoutSportsbook, 'currency') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(subTotalWinLoseSportsbook)" :title="$n(subTotalWinLoseSportsbook, 'currency')") {{ $n(subTotalWinLoseSportsbook, 'currency') }}
                                    br
                                    span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWinLoseSportsbook)" :title="$n(grandTotalWinLoseSportsbook, 'currency')") {{ $n(grandTotalWinLoseSportsbook, 'currency') }}
                                  td
                                  //- td
                                //- td
                    b-tab(title-link-class="small-link" title-item-class="small-item" v-if="showActionButton('gameresultcockfight')")
                      template(slot="title")
                        span(style="padding: 1px; line-height: 16px;") {{ $t("ui.cockfight") }}
                      div.d-flex.flex-wrap(style="min-height: 400px;")
                        div.clusterize
                          div.row.col-md-10.mb-2.text-uppercase
                            div(width="70%").mr-3
                              DateTimeRangePicker(:value="dateRangeCockfight" @update="getDataCockfight" ref="dateRangeCockfight")
                            div(width="30%")
                              SubmitButton(
                                :loading="loading"
                                icon="fa fa-search"
                                :text="$t('ui.search')"
                                type="button"
                                @click="getGameResultCockfight(true)"
                                variant="success"
                                size="sm"
                                )
                          div.row.mb-2
                            div.col-md-10
                              b-pagination.float-left(
                                size="sm"
                                hide-ellipsis
                                :total-rows="totalRowCockfight"
                                :per-page="getPageSize"
                                v-model="currentPageCockfight"
                                @input="changedPageCockfight($event)").mb-1
                            div.col-md-2
                              b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                                b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSizeCockfight")
                          .clusterize-scroll
                            table.tablex(style="width: 100%;")
                              thead
                                tr
                                  th.sticky-position(width="3%")
                                    span #
                                  th.sticky-position.sortable(width="12%" @click="sortOrder('bet_time', 'cockfight')")
                                    span(:title="$t('ui.date_time')") {{ $t('ui.date_time') }}
                                    i(:class="changeSortKey('bet_time', 'cockfight')")
                                  th.sticky-position(width="10%")
                                    span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                                  th.sticky-position.sortable(width="10%")
                                    span(:title="$t('ui.sports_game')") {{ $t('ui.sports_game') }}
                                  th.sticky-position.sortable(width="15%")
                                    span(:title="$t('ui.event')") {{ $t('ui.event') }}
                                  th.sticky-position.sortable(width="10%")
                                    span(:title="$t('ui.detail')") {{ $t('ui.detail') }}
                                  th.sticky-position.text-right.sortable(width="10%" @click="sortOrder('turnover', 'cockfight')")
                                    span(:title="$t('ui.turnover')") {{ $t('ui.turnover') }}
                                    i(:class="changeSortKey('turnover', 'cockfight')")
                                  th.sticky-position.text-right.sortable(width="10%" @click="sortOrder('valid_turnover', 'cockfight')")
                                    span(:title="$t('ui.valid_turnover')") {{ $t('ui.valid_turnover') }}
                                    i(:class="changeSortKey('valid_turnover', 'cockfight')")
                                  th.sticky-position.text-right.sortable(width="10%" @click="sortOrder('payout', 'cockfight')")
                                    span(:title="$t('ui.payout')") {{ $t('ui.payout') }}
                                    i(:class="changeSortKey('payout', 'cockfight')")
                                  th.sticky-position.text-right.sortable(width="10%" @click="sortOrder('winlose', 'cockfight')")
                                    span(:title="$t('ui.winlose')") {{ $t('ui.winlose') }}
                                    i(:class="changeSortKey('winlose', 'cockfight')")
                              tbody.clusterize-content
                                tr(v-if="cockfightList.length == 0")
                                  td(colspan="10").text-center
                                    span {{ $t('message.no_data_available') }}
                                template(v-for="(item, index) in cockfightList")
                                  tr
                                    td
                                      span(:title="((currentPageCockfight - 1) * getPageSize + index + 1)") {{ ((currentPageCockfight - 1) * getPageSize + index + 1) }}
                                    td
                                      span(:title="$moment(item.bet_time).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.bet_time).format('YYYY-MM-DD, HH:mm:ss') }}
                                      br
                                      span.font-weight-bold(:title="item.result_id") {{ item.result_id }}
                                    td
                                      span(:title="item.member_id") {{ item.member_id }}
                                    td
                                      span(:title="item.category") {{ item.category }}
                                    td
                                      span.font-weight-bold(:title="item.arena_fight_no") {{ item.arena_fight_no }}
                                      br
                                      span.text-primary(:title="item.result_detail") {{ item.result_detail }}
                                    td
                                      span(:title="item.player_hand") {{ item.player_hand }}
                                      br
                                      span(:title="item.odd ") {{ item.odd }}
                                    td.text-right
                                      span.font-weight-bold(:class="$helpers.fontClassName(item.turnover)" :title="$n(item.turnover, 'currency')") {{ $n(item.turnover, 'currency') }}
                                    td.text-right
                                      span.font-weight-bold(:class="$helpers.fontClassName(item.valid_turnover)" :title="$n(item.valid_turnover, 'currency')") {{ $n(item.valid_turnover, 'currency') }}
                                    td.text-right
                                      span.font-weight-bold(:class="$helpers.fontClassName(item.payout)" :title="$n(item.payout, 'currency')") {{ $n(item.payout, 'currency') }}
                                    td.text-right
                                      span.font-weight-bold(:class="$helpers.fontClassName(item.winlose)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                                tr(v-if="showTotalCockfight")
                                  td.text-right(colspan="6")
                                    span {{ $t("ui.sub_total") }}
                                    br
                                    span {{ $t("ui.grand_total") }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(subTotalTurnoverCockfight)" :title="$n(subTotalTurnoverCockfight, 'currency')") {{ $n(subTotalTurnoverCockfight, 'currency') }}
                                    br
                                    span.font-weight-bold(:class="$helpers.fontClassName(grandTotalTurnoverCockfight)" :title="$n(grandTotalTurnoverCockfight, 'currency')") {{ $n(grandTotalTurnoverCockfight, 'currency') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(subTotalValidTurnoverCockfight)" :title="$n(subTotalValidTurnoverCockfight, 'currency')") {{ $n(subTotalValidTurnoverCockfight, 'currency') }}
                                    br
                                    span.font-weight-bold(:class="$helpers.fontClassName(grandTotalValidTurnoverCockfight)" :title="$n(grandTotalValidTurnoverCockfight, 'currency')") {{ $n(grandTotalValidTurnoverCockfight, 'currency') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(subTotalPayoutCockfight)" :title="$n(subTotalPayoutCockfight, 'currency')") {{ $n(subTotalPayoutCockfight, 'currency') }}
                                    br
                                    span.font-weight-bold(:class="$helpers.fontClassName(grandTotalPayoutCockfight)" :title="$n(grandTotalPayoutCockfight, 'currency')") {{ $n(grandTotalPayoutCockfight, 'currency') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(subTotalWinLoseCockfight)" :title="$n(subTotalWinLoseCockfight, 'currency')") {{ $n(subTotalWinLoseCockfight, 'currency') }}
                                    br
                                    span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWinLoseCockfight)" :title="$n(grandTotalWinLoseCockfight, 'currency')") {{ $n(grandTotalWinLoseCockfight, 'currency') }}
                                  td
                    b-tab(title-link-class="small-link" title-item-class="small-item" v-if="showActionButton('gameresultrescue')")
                      template(slot="title")
                        span(style="padding: 1px; line-height: 16px;") {{ $t("ui.rescue") }}
                      div.d-flex.flex-wrap(style="min-height: 400px;")
                        div.clusterize
                          div.row.mb-2.text-uppercase
                            div.col-md-2.mb-1
                              b-input-group(size="sm")
                                b-input-group-text(slot="prepend")
                                  span {{ $t('ui.type') }}
                                DebounceInput(required autofocus type="text" v-model="rescueType" @enter="getGameResultRescue(true)")
                            div.row.col-md-10.mb-2.text-uppercase
                              div(width="70%").mr-3
                                DateRangePicker(:value="dateRangeRescue" @update="getDataRescue" ref="dateRangeRescue")
                              div(width="30%")
                                SubmitButton(
                                  :loading="loading"
                                  icon="fa fa-search"
                                  :text="$t('ui.search')"
                                  type="button"
                                  @click="getGameResultRescue(true)"
                                  variant="success"
                                  size="sm"
                                  )
                          div.row.mb-2
                            div.col-md-10
                              b-pagination.float-left(
                                size="sm"
                                hide-ellipsis
                                :total-rows="totalRowRescue"
                                :per-page="getPageSize"
                                v-model="currentPageRescue"
                                @input="changedPageRescue($event)").mb-1
                            div.col-md-2
                              b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                                b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSizeRescue")
                          .clusterize-scroll
                            table.tablex(style="width: 100%;")
                              thead
                                tr
                                  th.sticky-position(width="3%")
                                    span #
                                  th.sticky-position(width="17%")
                                    span(:title="$t('ui.result_id')") {{ $t('ui.result_id') }}
                                  th.sticky-position.text-right.sortable(width="12%" @click="sortOrder('bet_time', 'rescue')")
                                    span(:title="$t('ui.bet_time')") {{ $t('ui.bet_time') }}
                                    i(:class="changeSortKey('bet_time', 'rescue')")
                                  th.sticky-position.text-right.sortable(width="12%" @click="sortOrder('turnover', 'rescue')")
                                    span(:title="$t('ui.turnover')") {{ $t('ui.turnover') }}
                                    i(:class="changeSortKey('turnover', 'rescue')")
                                  th.sticky-position.text-right.sortable(width="12%" @click="sortOrder('valid_turnover', 'rescue')")
                                    span(:title="$t('ui.valid_turnover')") {{ $t('ui.valid_turnover') }}
                                    i(:class="changeSortKey('valid_turnover', 'rescue')")
                                  th.sticky-position.text-right.sortable(width="12%" @click="sortOrder('payout', 'rescue')")
                                    span(:title="$t('ui.payout')") {{ $t('ui.payout') }}
                                    i(:class="changeSortKey('payout', 'rescue')")
                                  th.sticky-position.text-right.sortable(width="12%" @click="sortOrder('winlose', 'rescue')")
                                    span(:title="$t('ui.winlose')") {{ $t('ui.winlose') }}
                                    i(:class="changeSortKey('winlose', 'rescue')")
                                  th.sticky-position.text-right(width="9%")
                                    span(:title="$t('ui.game_type')") {{ $t("ui.game_type") }}
                                  th.sticky-position.text-right(width="11%")
                                    span(:title="$t('ui.game_name')") {{ $t("ui.game_name") }}
                              tbody.clusterize-content
                                tr(v-if="rescueList.length == 0")
                                  td(colspan="9").text-center
                                    span {{ $t('message.no_data_available') }}
                                tr(v-for="(item, index) in rescueList")
                                  td
                                    span(:title="((currentPageRescue - 1) * getPageSize + index + 1)") {{ ((currentPageRescue - 1) * getPageSize + index + 1) }}
                                  td
                                    span(:title="item.result_id") {{ item.result_id }}
                                  td.text-right
                                    span(:title="$moment(item.bet_time).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.bet_time).format('YYYY-MM-DD, HH:mm:ss') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(item.turnover)" :title="$n(item.turnover, 'currency')") {{ $n(item.turnover, 'currency') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(item.valid_turnover)" :title="$n(item.valid_turnover, 'currency')") {{ $n(item.valid_turnover, 'currency') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(item.payout)" :title="$n(item.payout, 'currency')") {{ $n(item.payout, 'currency') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(item.winlose)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                                  td.text-right
                                    span(:title="item.game_type") {{ item.game_type }}
                                  td.text-right
                                    span(:title="item.game_name") {{ item.game_name }}
                                tr(v-if="showTotalRescue")
                                  td.text-right(colspan="3")
                                    span {{ $t("ui.sub_total") }}
                                    br
                                    span {{ $t("ui.grand_total") }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(subTotalTurnoverRescue)" :title="$n(subTotalTurnoverRescue, 'currency')") {{ $n(subTotalTurnoverRescue, 'currency') }}
                                    br
                                    span.font-weight-bold(:class="$helpers.fontClassName(grandTotalTurnoverRescue)" :title="$n(grandTotalTurnoverRescue, 'currency')") {{ $n(grandTotalTurnoverRescue, 'currency') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(subTotalValidTurnoverRescue)" :title="$n(subTotalValidTurnoverRescue, 'currency')") {{ $n(subTotalValidTurnoverRescue, 'currency') }}
                                    br
                                    span.font-weight-bold(:class="$helpers.fontClassName(grandTotalValidTurnoverRescue)" :title="$n(grandTotalValidTurnoverRescue, 'currency')") {{ $n(grandTotalValidTurnoverRescue, 'currency') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(subTotalPayoutRescue)" :title="$n(subTotalPayoutRescue, 'currency')") {{ $n(subTotalPayoutRescue, 'currency') }}
                                    br
                                    span.font-weight-bold(:class="$helpers.fontClassName(grandTotalPayoutRescue)" :title="$n(grandTotalPayoutRescue, 'currency')") {{ $n(grandTotalPayoutRescue, 'currency') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(subTotalWinLoseRescue)" :title="$n(subTotalWinLoseRescue, 'currency')") {{ $n(subTotalWinLoseRescue, 'currency') }}
                                    br
                                    span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWinLoseRescue)" :title="$n(grandTotalWinLoseRescue, 'currency')") {{ $n(grandTotalWinLoseRescue, 'currency') }}
                                  td
                                  td
                                  //- td
                    b-tab(title-link-class="small-link" title-item-class="small-item" v-if="showActionButton('providerwinlosemember')")
                      template(slot="title")
                        span(style="padding: 1px; line-height: 16px;") {{ $t("ui.winlose") }}
                      div.d-flex.flex-wrap(style="min-height: 400px;")
                        div.clusterize
                          div.row.col-md-10.mb-2.text-uppercase
                            div(width="70%").mr-3
                              DateRangePicker(:value="dateRangeWinlose" @update="getDataWinlose" ref="dateRangeWinlose")
                            div(width="30%")
                              SubmitButton(
                                :loading="loading"
                                icon="fa fa-search"
                                :text="$t('ui.search')"
                                type="button"
                                @click="getProviderWinLose(true)"
                                variant="success"
                                size="sm"
                                )
                          div.row.mb-2
                            div.col-md-10
                              b-pagination.float-left(
                                size="sm"
                                hide-ellipsis
                                :total-rows="totalRowWinlose"
                                :per-page="getPageSize"
                                v-model="currentPageWinlose"
                                @input="changedPageWinlose($event)").mb-1
                            div.col-md-2
                              b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                                b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSizeWinlose")
                          .clusterize-scroll
                            table.tablex(style="width: 100%;")
                              thead
                                tr
                                  th.sticky-position.sortable(width="10%" @click="sortOrder('account_id', 'winlose')")
                                    span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                                    i(:class="changeSortKey('account_id', 'winlose')")
                                  th.sticky-position.sortable(width="10%" @click="sortOrder('category', 'winlose')")
                                    span(:title="$t('ui.category')") {{ $t('ui.category') }}
                                    i(:class="changeSortKey('category', 'winlose')")
                                  th.sticky-position.sortable(width="10%" @click="sortOrder('provider_code', 'winlose')")
                                    span(:title="$t('ui.provider_code')") {{ $t('ui.provider_code') }}
                                    i(:class="changeSortKey('provider_code', 'winlose')")
                                  th.sticky-position(width="15%")
                                    span(:title="$t('ui.provider_name')") {{ $t('ui.provider_name') }}
                                  th.sticky-position.text-right.sortable(width="15%" @click="sortOrder('winlose', 'winlose')")
                                    span(:title="$t('ui.winlose')") {{ $t('ui.winlose') }}
                                    i(:class="changeSortKey('winlose', 'winlose')")
                                  th.sticky-position.text-right.sortable(width="15%" @click="sortOrder('turnover', 'winlose')")
                                    span(:title="$t('ui.turnover')") {{ $t('ui.turnover') }}
                                    i(:class="changeSortKey('turnover', 'winlose')")
                                  th.sticky-position.text-right.sortable(width="15%" @click="sortOrder('valid_turnover', 'winlose')")
                                    span(:title="$t('ui.valid_turnover')") {{ $t('ui.valid_turnover') }}
                                    i(:class="changeSortKey('valid_turnover', 'winlose')")
                              tbody.clusterize-content
                                tr(v-if="winloseList.length == 0")
                                  td(colspan="7").text-center
                                    span {{ $t('message.no_data_available') }}
                                template(v-for="(item, index) in winloseList")
                                  tr
                                    td
                                      span(:title="item.account_id") {{ item.account_id }}
                                    td
                                      span(:title="item.category") {{ item.category }}
                                    td
                                      span(:title="item.provider_code") {{ item.provider_code }}
                                    td
                                      span(:title="item.provider_name") {{ item.provider_name }}
                                    td.text-right
                                      span.font-weight-bold(:class="$helpers.fontClassName(item.winlose, true)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                                    td.text-right
                                      span.font-weight-bold(:class="$helpers.fontClassName(item.turnover, true)" :title="$n(item.turnover, 'currency')") {{ $n(item.turnover, 'currency') }}
                                    td.text-right
                                      span.font-weight-bold(:class="$helpers.fontClassName(item.valid_turnover, true)" :title="$n(item.valid_turnover, 'currency')") {{ $n(item.valid_turnover, 'currency') }}
                                tr(v-if="showTotalWinlose")
                                  td.text-right(colspan="4")
                                    span {{ $t("ui.sub_total") }}
                                    br
                                    span {{ $t("ui.grand_total") }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(subTotalWinLoseProvider)" :title="$n(subTotalWinLoseProvider, 'currency')") {{ $n(subTotalWinLoseProvider, 'currency') }}
                                    br
                                    span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWinLoseProvider)" :title="$n(grandTotalWinLoseProvider, 'currency')") {{ $n(grandTotalWinLoseProvider, 'currency') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(subTotalTurnoverProvider)" :title="$n(subTotalTurnoverProvider, 'currency')") {{ $n(subTotalTurnoverProvider, 'currency') }}
                                    br
                                    span.font-weight-bold(:class="$helpers.fontClassName(grandTotalTurnoverProvider)" :title="$n(grandTotalTurnoverProvider, 'currency')") {{ $n(grandTotalTurnoverProvider, 'currency') }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(subTotalValidTurnoverProvider)" :title="$n(subTotalValidTurnoverProvider, 'currency')") {{ $n(subTotalValidTurnoverProvider, 'currency') }}
                                    br
                                    span.font-weight-bold(:class="$helpers.fontClassName(grandTotalValidTurnoverProvider)" :title="$n(grandTotalValidTurnoverProvider, 'currency')") {{ $n(grandTotalValidTurnoverProvider, 'currency') }}
            b-card.mb-1(no-body='')
              b-card-header.p-1(header-tag='header' role='tab')
                b-button.btn.btn-link(block='' v-b-toggle.accordion-4='' variant='warning') {{ $t('ui.ip_info') }}
              b-collapse#accordion-4(role='tabpanel')
                b-card-body
                  div.row.mb-2(v-if="pageLvlIp == 'summary'")
                    div.col-md-3.mb-1
                      b-input-group(size="sm")
                        b-input-group-text(slot="prepend")
                          span {{ $t('ui.action_by') }}
                        DebounceInput(type="text" v-model="searchIp" @enter="getIpAssociateList(true)")
                    div.col-md-7.mb-1
                      SubmitButton(
                        :loading="loading"
                        icon="fa fa-search"
                        :text="$t('ui.search')"
                        type="button"
                        @click="getIpAssociateList(true)"
                        variant="success"
                        size="sm"
                        )
                  div.row.mb-1(v-if="pageLvlIp == 'detail'")
                    div.col-md-3.mb-1
                      SubmitButton(
                        :loading="loading"
                        icon="icon-arrow-left"
                        :text="$t('ui.back')"
                        type="button"
                        @click="backToSummaryLvl"
                        variant="secondary"
                        size="sm"
                        ).mb-1.mr-1
                  div.mb-2(v-if="pageLvlIp == 'summary'")
                    div.row.mb-1
                      div.col-md-10
                        b-pagination.float-left(
                          size="sm"
                          hide-ellipsis
                          :total-rows="totalRowIp"
                          :per-page="getPageSize"
                          v-model="currentPageIp"
                          @input="changedPageIp($event)").mb-1
                      div.col-md-2
                        b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSizeIp")
                  div.mb-2(v-if="pageLvlIp == 'detail'")
                    div.row.mb-1
                      div.col-md-10
                        b-pagination.float-left(
                          size="sm"
                          hide-ellipsis
                          :total-rows="totalRowAudit"
                          :per-page="getPageSize"
                          v-model="currentPageAudit"
                          @input="changedPageAudit($event)").mb-1
                      div.col-md-2
                        b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSizeIp")
                  div.row(v-if="pageLvlIp == 'summary'")
                    div.col-sm-12.col-md-12.col-lg-12
                      table.tablex(width="100%")
                        thead
                          tr
                            th.sticky-position(width="10%")
                              span #
                            th.sticky-position(width="25%")
                              span(:title="$t('ui.action_by')") {{ $t("ui.action_by") }}
                            th.sticky-position(width="25%")
                              span(:title="$t('ui.action_date')") {{ $t("ui.action_date") }}
                            th.sticky-position(width="20%")
                              span(:title="$t('ui.login_ip')") {{ $t("ui.login_ip") }}
                            th.sticky-position(width="20%")
                              span(:title="$t('ui.login_count')") {{ $t("ui.login_count") }}
                        tbody
                          tr(v-if="ipList.length == 0")
                            td(colspan="5").text-center
                              span {{ $t('message.no_data_available') }}
                          tr(v-for="(item, index) in ipList")
                            td
                              span(:title="((currentPageIp - 1) * getPageSize + index + 1)") {{ ((currentPageIp - 1) * getPageSize + index + 1) }}
                            td
                              span(:title="item.action_by") {{ item.action_by }}
                            td
                              span(:title="$moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss') }}
                            td
                              span(:title="item.login_ip")
                                b-link.clickable(href="javascript:void(0);" @click="setLoginIp(item)") {{ item.login_ip }}
                            td
                              span(:title="$n(item.login_count, 'integer')") {{ $n(item.login_count, 'integer') }}
                  div.row(v-if="pageLvlIp == 'detail'")
                    div.col-sm-12.col-md-12.col-lg-12
                      table.tablex(width="100%")
                        thead
                          tr
                            th.sticky-position(width="10%")
                              span #
                            th.sticky-position(width="20%")
                              span(:title="$t('ui.login_ip')") {{ $t("ui.login_ip") }}
                            th.sticky-position(width="20%")
                              span(:title="$t('ui.action_status')") {{ $t("ui.action_status") }}
                            th.sticky-position(width="25%")
                              span(:title="$t('ui.action_by')") {{ $t("ui.action_by") }}
                            th.sticky-position(width="25%")
                              span(:title="$t('ui.action_date')") {{ $t("ui.action_date") }}
                        tbody
                          tr(v-if="auditLoginList.length == 0")
                            td(colspan="5").text-center
                              span {{ $t('message.no_data_available') }}
                          tr(v-for="(item, index) in auditLoginList")
                            td
                              span(:title="((currentPageAudit - 1) * getPageSize + index + 1)") {{ ((currentPageAudit - 1) * getPageSize + index + 1) }}
                            td
                              span(:title="item.login_ip") {{ item.login_ip }}
                            td
                              span(:class="{'text-success': item.action_type.toUpperCase() == 'SUCCESS', 'text-danger': item.action_type.toUpperCase() == 'FAILED'  }" :title="item.action_type") {{ item.action_type }}
                            td
                              span(:title="item.action_by") {{ item.action_by }}
                            td
                              span(:title="$moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss') }}
            b-card.mb-1(no-body='')
              b-card-header.p-1(header-tag='header' role='tab')
                b-button(block='' v-b-toggle.accordion-5='' variant='danger') {{ $t('ui.log') }}
              b-collapse#accordion-5( role='tabpanel')
                b-card-body
                  b-tabs(small card)
                    b-tab(title-link-class="small-link" title-item-class="small-item" v-if="showActionButton('adjustmemberlog')")
                      template(slot="title")
                        span(style="padding: 1px; line-height: 16px;") {{ $t("ui.adjustment") }}
                      div.d-flex.flex-wrap(style="min-height: 400px;")
                        div.clusterize
                          div.row.col-md-10.mb-2.text-uppercase
                            div(width="50%").mr-3
                              DateRangePicker(:value="dateRangeAdjust" @update="getDataAdjust" ref="dateRangeAdjust")
                            div(width="20%").mr-3
                              b-input-group(size="sm").mb-1
                                b-input-group-text(slot="prepend")
                                  span {{ $t('ui.signup_bonus') }}
                                b-input-group-text(slot="append")
                                  div.d-flex.justify-content-center.align-items-center
                                    label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                                      input.switch-input(type="checkbox" v-model="signupBonus")
                                      span.switch-slider(:data-checked='on' :data-unchecked='off')
                            div(width="20%").mr-3
                              b-input-group(size="sm")
                                b-input-group-text(slot="prepend")
                                  span {{ $t('ui.amount') }}
                                b-form-select(v-model="filterAmount" @change="getAdjustmentList(true)")
                                  option(value="1") {{ $t('ui.all') }}
                                  option(value="2") {{ $t('ui.credit') }}
                                  option(value="3") {{ $t("ui.debit") }}
                            div(width="10%")
                              SubmitButton(
                                :loading="loading"
                                icon="fa fa-search"
                                :text="$t('ui.search')"
                                type="button"
                                @click="getAdjustmentList(true)"
                                variant="success"
                                size="sm"
                                )
                          div.row.mb-2
                            div.col-md-10
                              b-pagination.float-left(
                                size="sm"
                                hide-ellipsis
                                :total-rows="totalRowAdjust"
                                :per-page="getPageSize"
                                v-model="currentPageAdjust"
                                @input="changedPageAdjust($event)").mb-1
                            div.col-md-2
                              b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                                b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSizeAdjust")
                          .clusterize-scroll
                            table.tablex(style="width: 100%;")
                              thead
                                tr
                                  th.sticky-position(width="3%")
                                    span #
                                  th.sticky-position.sortable(width="11%" @click="sortOrder('member_id', 'adjust')")
                                    span(:title="$t('ui.member_id')") {{ $t('ui.member_id') }}
                                    i(:class="changeSortKey('member_id', 'adjust')")
                                  th.sticky-position(width="15%")
                                    span(:title="$t('ui.balance_before')") {{ $t('ui.balance_before') }}
                                  th.sticky-position.sortable(width="15%" @click="sortOrder('amount', 'adjust')")
                                    span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
                                    i(:class="changeSortKey('amount', 'adjust')")
                                  th.sticky-position(width="15%")
                                    span(:title="$t('ui.balance_after')") {{ $t('ui.balance_after') }}
                                  th.sticky-position.sortable(width="17%" @click="sortOrder('remark', 'adjust')")
                                    span(:title="$t('ui.remark')") {{ $t('ui.remark') }}
                                    i(:class="changeSortKey('remark', 'adjust')")
                                  th.sticky-position.sortable(width="11%" @click="sortOrder('created_by', 'adjust')")
                                    span(:title="$t('ui.created_by')") {{ $t('ui.created_by') }}
                                    i(:class="changeSortKey('created_by', 'adjust')")
                                  th.sticky-position.text-right.sortable(width="13%" @click="sortOrder('created_date', 'adjust')")
                                    span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                                    i(:class="changeSortKey('created_date', 'adjust')")
                              tbody.clusterize-content
                                tr(v-if="adjustmentList.length == 0")
                                  td(colspan="8").text-center
                                    span {{ $t('message.no_data_available') }}
                                tr(v-for="(item, index) in adjustmentList")
                                  td
                                    span(:title="((currentPageAdjust - 1) * getPageSize + index + 1)") {{ ((currentPageAdjust - 1) * getPageSize + index + 1) }}
                                  td
                                    span(:title="item.member_id") {{ item.member_id }}
                                  td
                                    span.font-weight-bold(:class="$helpers.fontClassName(item.balance_before)" :title="$n(item.balance_before, 'currency')") {{ $n(item.balance_before, 'currency') }}
                                  td
                                    span.font-weight-bold(:class="$helpers.fontClassName(item.amount)" :title="$n(item.amount, 'currency')") {{ $n(item.amount, 'currency') }}
                                  td
                                    span.font-weight-bold(:class="$helpers.fontClassName(item.balance_after)" :title="$n(item.balance_after, 'currency')") {{ $n(item.balance_after, 'currency') }}
                                  td
                                    span(:title="item.remark") {{ item.remark }}
                                  td
                                    span(:title="item.created_by") {{ item.created_by }}
                                  td.text-right
                                    span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
                                tr(v-if="showTotalAdjust")
                                  td.text-right(colspan="3")
                                    span {{ $t("ui.sub_total") }}
                                    br
                                    span {{ $t("ui.grand_total") }}
                                  td(colspan="5")
                                    span.font-weight-bold(:class="$helpers.fontClassName(subTotalAmountAdjust)" :title="$n(subTotalAmountAdjust, 'currency')") {{ $n(subTotalAmountAdjust, 'currency') }}
                                    br
                                    span.font-weight-bold(:class="$helpers.fontClassName(grandTotalAmountAdjust)" :title="$n(grandTotalAmountAdjust, 'currency')") {{ $n(grandTotalAmountAdjust, 'currency') }}
                    b-tab(title-link-class="small-link" title-item-class="small-item" v-if="showActionButton('issuebonuslog')")
                      template(slot="title")
                        span(style="padding: 1px; line-height: 16px;") {{ $t("ui.bonus") }}
                      div.d-flex.flex-wrap(style="min-height: 400px;")
                        div.clusterize
                          div.row.col-md-10.mb-2.text-uppercase
                            div(width="50%").mr-3
                              DateRangePicker(:value="dateRangeBonus" @update="getDataBonus" ref="dateRangeBonus")
                            div(width="20%").mr-3
                              b-input-group(size="sm").mb-1
                                b-input-group-text(slot="prepend")
                                  span {{ $t('ui.manual_bonus') }}
                                b-input-group-text(slot="append")
                                  div.d-flex.justify-content-center.align-items-center
                                    label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                                      input.switch-input(type="checkbox" v-model="manualBonus")
                                      span.switch-slider(:data-checked='on' :data-unchecked='off')
                            div(width="30%")
                              SubmitButton(
                                :loading="loading"
                                icon="fa fa-search"
                                :text="$t('ui.search')"
                                type="button"
                                @click="getBonusList(true)"
                                variant="success"
                                size="sm"
                                )
                          div.row.mb-2
                            div.col-md-10
                              b-pagination.float-left(
                                size="sm"
                                hide-ellipsis
                                :total-rows="totalRowBonus"
                                :per-page="getPageSize"
                                v-model="currentPageBonus"
                                @input="changedPageBonus($event)").mb-1
                            div.col-md-2
                              b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                                b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSizeBonus")
                          .clusterize-scroll
                            table.tablex(style="width: 100%;")
                              thead
                                tr
                                  th.sticky-position(width="3%")
                                    span #
                                  th.sticky-position.sortable(width="11%" @click="sortOrder('member_id', 'bonus')")
                                    span(:title="$t('ui.member_id')") {{ $t('ui.member_id') }}
                                    i(:class="changeSortKey('member_id', 'bonus')")
                                  th.sticky-position.sortable(width="19%" @click="sortOrder('bonus_name', 'bonus')")
                                    span(:title="$t('ui.bonus_name')") {{ $t('ui.bonus_name') }}
                                    i(:class="changeSortKey('bonus_name', 'bonus')")
                                  th.sticky-position.sortable(width="20%" @click="sortOrder('bonus_desc', 'bonus')")
                                    span(:title="$t('ui.bonus_desc')") {{ $t('ui.bonus_desc') }}
                                    i(:class="changeSortKey('bonus_desc', 'bonus')")
                                  th.sticky-position.sortable(width="9%" @click="sortOrder('bonus_type', 'bonus')")
                                    span(:title="$t('ui.bonus_type')") {{ $t('ui.bonus_type') }}
                                    i(:class="changeSortKey('bonus_type', 'bonus')")
                                  th.sticky-position.text-right.sortable(width="14%" @click="sortOrder('bonus_value', 'bonus')")
                                    span(:title="$t('ui.bonus_value')") {{ $t('ui.bonus_value') }}
                                    i(:class="changeSortKey('bonus_value', 'bonus')")
                                  th.sticky-position.sortable(width="11%" @click="sortOrder('created_by', 'bonus')")
                                    span(:title="$t('ui.created_by')") {{ $t('ui.created_by') }}
                                    i(:class="changeSortKey('created_by', 'bonus')")
                                  th.sticky-position.text-right.sortable(width="13%" @click="sortOrder('created_date', 'bonus')")
                                    span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                                    i(:class="changeSortKey('created_date', 'bonus')")
                              tbody.clusterize-content
                                tr(v-if="bonusList.length == 0")
                                  td(colspan="8").text-center
                                    span {{ $t('message.no_data_available') }}
                                tr(v-for="(item, index) in bonusList")
                                  td
                                    span(:title="((currentPageBonus - 1) * getPageSize + index + 1)") {{ ((currentPageBonus - 1) * getPageSize + index + 1) }}
                                  td
                                    span(:title="item.member_id") {{ item.member_id }}
                                  td
                                    span(:title="item.bonus_name") {{ item.bonus_name }}
                                  td
                                    span(:title="item.bonus_desc") {{ item.bonus_desc }}
                                  td
                                    span(:title="item.bonus_type") {{ item.bonus_type }}
                                  td.text-right
                                    span.font-weight-bold(:title="$n(item.bonus_value, 'currency')") {{ $n(item.bonus_value, 'currency') }}
                                  td
                                    span(:title="item.created_by") {{ item.created_by }}
                                  td.text-right
                                    span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
                                tr(v-if="showTotalBonus")
                                  td.text-right(colspan="5")
                                    span {{ $t("ui.sub_total") }}
                                    br
                                    span {{ $t("ui.grand_total") }}
                                  td.text-right
                                    span.font-weight-bold(:class="$helpers.fontClassName(subTotalAmountBonus)" :title="$n(subTotalAmountBonus, 'currency')") {{ $n(subTotalAmountBonus, 'currency') }}
                                    br
                                    span.font-weight-bold(:class="$helpers.fontClassName(grandTotalAmountBonus)" :title="$n(grandTotalAmountBonus, 'currency')") {{ $n(grandTotalAmountBonus, 'currency') }}
                                  td(colspan="2")
      div(slot="modal-ok")
        SubmitButton(:loading="loading" icon="fa fa-check" :text="$t('ui.close')" isModal=true)
      //- div(slot="modal-footer")
      //-   SubmitButton.float-right(icon="far fa-times-circle" :text="$t('ui.close')" @click="closeModal()" size="sm" variant="primary").mr-1
    editmember(ref="editmember" :item="editSelectedMember" @clicked="afterEditMember" @failed="handleFailed")
    adjustmember(ref="adjustmember" :item="editSelectedMember" @clicked="afterAdjustMember" @failed="handleFailed")
    resetpasswordmember(ref="resetpasswordmember" :item="editSelectedMember" @clicked="afterResetPasswordMember" @failed="handleFailed")
    gettac(ref="gettac" :item="editSelectedMember" @failed="handleFailed")
    getbanktac(ref="getbanktac" :item="editSelectedMember" @failed="handleFailed")
    raisedepositticket(ref="raisedepositticket" :item="editSelectedMember" @clicked="afterRaiseDepositTicket" @failed="handleFailed")
    bonusissue(ref="bonusissue" :item="editSelectedMember" @clicked="afterIssueBonus" @failed="handleFailed")
    promomemberassign(ref="promomemberassign" :item="editSelectedMember" @clicked="afterPromoMemberAssign" @failed="handleFailed")
    updatevip(ref="updatevip" :item="editSelectedMember" @clicked="afterUpdateVip" @failed="handleFailed")
    updatememberprofile(ref="updatememberprofile" :item="editSelectedMember" @clicked="afterUpdateMemberProfile" @failed="handleFailed")
    updatememberbetlimit(ref="updatememberbetlimit" :item="editSelectedMember" @clicked="afterUpdateMemberBetLimit" @failed="handleFailed")
    getinboxlist(ref="getinboxlist" :item="editSelectedMember" @failed="handleFailed")
    membersummary(ref="membersummary" :item="editSelectedMember" @failed="handleFailed")
    getrebate(ref="getrebate" :item="editSelectedMember" @failed="handleFailed")
    checkmemberfreespin(ref="checkmemberfreespin" :item="editSelectedMember" @failed="handleFailed")
    clearoutstanding(ref="clearoutstanding" :item="editSelectedMember" @clicked="afterClearOutstanding" @failed="handleFailed")
    raisedepositticketgateway(ref="raisedepositticketgateway" :item="editSelectedMember" @clicked="afterRaiseDepositTicketGateway" @failed="handleFailed")
    upsertlabel(ref="upsertlabel" :item="editSelectedMember" @clicked="afterUpsertLabel" @failed="handleFailed")
    issuefreespin(ref="issuefreespin" :item="editSelectedMember" @clicked="afterIssueFreeSpin" @failed="handleFailed")
</template>

<script>
import { required, minLength, maxLength, url } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import DebounceInput from "@/library/DebounceInput";
import editmember from "@/components/member/editMember.vue";
import adjustmember from "@/components/member/adjustMember.vue";
import resetpasswordmember from "@/components/member/resetPasswordMember.vue";
import raisedepositticket from "@/components/member/raiseDepositTicket.vue";
import gettac from "@/components/member/getTac.vue";
import getbanktac from "@/components/member/getBankTac.vue";
import bonusissue from "@/components/member/bonusIssue.vue";
import promomemberassign from "@/components/member/promoMemberAssign.vue";
import updatevip from "@/components/member/updateVip.vue";
import updatememberprofile from "@/components/member/updateMemberProfile.vue";
import updatememberbetlimit from "@/components/member/updateMemberBetLimit.vue";
import getinboxlist from "@/components/member/getInboxList.vue";
import membersummary from "@/components/member/memberSummary.vue";
import getrebate from "@/components/member/getRebate.vue";
import checkmemberfreespin from "@/components/member/checkMemberFreeSpin.vue";
import clearoutstanding from "@/components/member/clearOutstanding.vue";
import {resizeColumn1} from '@/main';
import DateTimeRangePicker from "@/library/DateTimeRangePicker.vue";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css';
import 'vue2-daterange-picker/dist/lib/vue-daterange-picker2.min.css';
import ProviderLookup from "@/library/ProviderLookup.vue";
import raisedepositticketgateway from "@/components/member/raiseDepositTicketGateway.vue";
import upsertlabel from "@/components/member/upsertLabel.vue";
import issuefreespin from "@/components/member/issueFreeSpin.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    editmember,
    adjustmember,
    resetpasswordmember,
    gettac,
    getbanktac,
    raisedepositticket,
    bonusissue,
    promomemberassign,
    updatevip,
    updatememberprofile,
    updatememberbetlimit,
    getinboxlist,
    membersummary,
    getrebate,
    checkmemberfreespin,
    clearoutstanding,
    DateRangePicker,
    DateTimeRangePicker,
    ProviderLookup,
    raisedepositticketgateway,
    upsertlabel,
    issuefreespin
  },
  props: {
    // item:{
    //   type: Object,
    //   default: null
    // },
    memberId:{
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      search: "",
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
      editSelectedMember: null,
      info: null,
      loginList: [],
      depositList: [],
      withdrawalList: [],
      labelList: [],
      validTurnover: null,
      winlose: null,
      wallet: null,
      member: null,
      ftd: null,
      mbmFound: null,
      promoName: "",
      promoAccumulate: 0,
      promoTarget: 0,
      promoCriteria: "",
      bonusAmount: 0,
      promoID: "",
      promoDate: null,
      ftdDate: null,
      ftdAmount: 0,
      currentVip: "",
      nextVip: "",
      possibleNextVip: "",
      vipDepositAcc: 0,
      vipDepositTarget: 0,
      vipTurnoverAcc: 0,
      vipTurnoverTarget: 0,
      rewardTypeNext: "",
      csNext: "",
      cashNext: 0,
      spNext: "",
      lastCycle: null,
      nextCycle: null,
      locale: {
        format: "YYYY-MM-DD",
        useCurrent: true
      },
      resultDetailUrl: "",
      resultDetailProvider: config.resultDetailProvider,
      memberLabel: null,

      dateRangeSlots: {
        startDate: null,
        endDate: null,
      },
      slotsList: [],
      currentPageSlots: 1,
      sortKeySlots: "bet_time",
      sortTypeSlots: "desc",
      totalRowSlots: 0,
      showTotalSlots: false,
      providerSlots: "",
      subTotalTurnoverSlots: 0,
      grandTotalTurnoverSlots: 0,
      subTotalValidTurnoverSlots: 0,
      grandTotalValidTurnoverSlots: 0,
      subTotalWinLoseSlots: 0,
      grandTotalWinLoseSlots: 0,
      subTotalPayoutSlots: 0,
      grandTotalPayoutSlots: 0,

      dateRangeLivecasino: {
        startDate: null,
        endDate: null,
      },
      livecasinoList: [],
      currentPageLivecasino: 1,
      sortKeyLivecasino: "bet_time",
      sortTypeLivecasino: "desc",
      totalRowLivecasino: 0,
      showTotalLivecasino: false,
      providerLivecasino: "",
      tableIdLivecasino: "",
      subTotalTurnoverLivecasino: 0,
      grandTotalTurnoverLivecasino: 0,
      subTotalValidTurnoverLivecasino: 0,
      grandTotalValidTurnoverLivecasino: 0,
      subTotalWinLoseLivecasino: 0,
      grandTotalWinLoseLivecasino: 0,
      subTotalPayoutLivecasino: 0,
      grandTotalPayoutLivecasino: 0,

      dateRangeRebate: {
        startDate: null,
        endDate: null,
      },
      rebateList: [],
      currentPageRebate: 1,
      sortKeyRebate: "bet_time",
      sortTypeRebate: "desc",
      totalRowRebate: 0,
      showTotalRebate: false,
      subTotalTurnoverRebate: 0,
      grandTotalTurnoverRebate: 0,
      subTotalValidTurnoverRebate: 0,
      grandTotalValidTurnoverRebate: 0,
      subTotalWinLoseRebate: 0,
      grandTotalWinLoseRebate: 0,
      subTotalPayoutRebate: 0,
      grandTotalPayoutRebate: 0,
      rebateType: "",

      dateRangeSportsbook: {
        startDate: null,
        endDate: null,
      },
      sportsbookList: [],
      currentPageSportsbook: 1,
      sortKeySportsbook: "bet_time",
      sortTypeSportsbook: "desc",
      totalRowSportsbook: 0,
      showTotalSportsbook: false,
      subTotalTurnoverSportsbook: 0,
      grandTotalTurnoverSportsbook: 0,
      subTotalValidTurnoverSportsbook: 0,
      grandTotalValidTurnoverSportsbook: 0,
      subTotalWinLoseSportsbook: 0,
      grandTotalWinLoseSportsbook: 0,
      subTotalPayoutSportsbook: 0,
      grandTotalPayoutSportsbook: 0,
      currId: null,
      isShowDetail: false,

      dateRangeCockfight: {
        startDate: null,
        endDate: null,
      },
      cockfightList: [],
      currentPageCockfight: 1,
      sortKeyCockfight: "bet_time",
      sortTypeCockfight: "desc",
      totalRowCockfight: 0,
      showTotalCockfight: false,
      subTotalTurnoverCockfight: 0,
      grandTotalTurnoverCockfight: 0,
      subTotalValidTurnoverCockfight: 0,
      grandTotalValidTurnoverCockfight: 0,
      subTotalWinLoseCockfight: 0,
      grandTotalWinLoseCockfight: 0,
      subTotalPayoutCockfight: 0,
      grandTotalPayoutCockfight: 0,

      dateRangeRescue: {
        startDate: null,
        endDate: null,
      },
      rescueList: [],
      currentPageRescue: 1,
      sortKeyRescue: "bet_time",
      sortTypeRescue: "desc",
      totalRowRescue: 0,
      showTotalRescue: false,
      subTotalTurnoverRescue: 0,
      grandTotalTurnoverRescue: 0,
      subTotalValidTurnoverRescue: 0,
      grandTotalValidTurnoverRescue: 0,
      subTotalWinLoseRescue: 0,
      grandTotalWinLoseRescue: 0,
      subTotalPayoutRescue: 0,
      grandTotalPayoutRescue: 0,
      rescueType: "",

      ipList: [],
      currentPageIp: 1,
      sortKeyIp: "action_date",
      sortTypeIp: "desc",
      totalRowIp: 0,
      searchIp: "",
      pageLvlIp: "summary",

      selectedLoginIp: null,
      totalRowAudit: 0,
      auditLoginList: [],

      bankList: [],

      dateRangeAdjust: {
        startDate: null,
        endDate: null,
      },
      adjustmentList: [],
      currentPageAdjust: 1,
      sortKeyAdjust: "created_date",
      sortTypeAdjust: "desc",
      totalRowAdjust: 0,
      showTotalAdjust: false,
      subTotalAmountAdjust: 0,
      grandTotalAmountAdjust: 0,
      signupBonus: false,
      filterAmount: 1,

      dateRangeBonus: {
        startDate: null,
        endDate: null,
      },
      bonusList: [],
      currentPageBonus: 1,
      sortKeyBonus: "created_date",
      sortTypeBonus: "desc",
      totalRowBonus: 0,
      showTotalBonus: false,
      subTotalAmountBonus: 0,
      grandTotalAmountBonus: 0,
      manualBonus: false,

      dateRangeWinlose: {
        startDate: null,
        endDate: null,
      },
      winloseList: [],
      currentPageWinlose: 1,
      sortKeyWinlose: "account_id",
      sortTypeWinlose: "asc",
      totalRowWinlose: 0,
      showTotalWinlose: false,
      subTotalWinLoseProvider: 0,
      grandTotalWinLoseProvider: 0,
      subTotalTurnoverProvider: 0,
      grandTotalTurnoverProvider: 0,
      subTotalValidTurnoverProvider: 0,
      grandTotalValidTurnoverProvider: 0,

      dateRangeStatement: {
        startDate: null,
        endDate: null,
      },
      statementList: [],
      currentPageStatement: 1,
      sortKeyStatement: "working_date",
      sortTypeStatement: "desc",
      totalRowStatement: 0,
      showTotalStatement: false,
      subTotalTurnoverStatement: 0,
      grandTotalTurnoverStatement: 0,
      subTotalValidTurnoverStatement: 0,
      grandTotalValidTurnoverStatement: 0,
      subTotalWinLoseStatement: 0,
      grandTotalWinLoseStatement: 0,
      subTotalDepositAmounStatementt: 0,
      grandTotalDepositAmountStatement: 0,
      subTotalWithdrawalAmountStatement: 0,
      grandTotalWithdrawalAmountStatement: 0,
      subTotalBonusAmountStatement: 0,
      grandTotalBonusAmountStatement: 0,
      subTotalAdjustmentAmountStatement: 0,
      grandTotalAdjustmentAmountStatement: 0,
      subTotalRefereeCountStatement: 0,
      grandTotalRefereeCountStatement: 0,
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    currentMonth() {
      return this.$moment(new Date).format("MMMM");
    },
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
  },
  mounted: function() {
    // this.getMemberSummary();
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.dateRangeSlots.startDate = this.$moment(new Date).format('YYYY-MM-DD 00:00:00');
      this.dateRangeSlots.endDate = this.$moment(new Date).format('YYYY-MM-DD 23:59:59');
      this.dateRangeLivecasino.startDate = this.$moment(new Date).format('YYYY-MM-DD 00:00:00');
      this.dateRangeLivecasino.endDate = this.$moment(new Date).format('YYYY-MM-DD 23:59:59');
      this.dateRangeRebate.startDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.dateRangeRebate.endDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.dateRangeSportsbook.startDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.dateRangeSportsbook.endDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.dateRangeCockfight.startDate = this.$moment(new Date).format('YYYY-MM-DD 00:00:00');
      this.dateRangeCockfight.endDate = this.$moment(new Date).format('YYYY-MM-DD 23:59:59');
      this.dateRangeRescue.startDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.dateRangeRescue.endDate = this.$moment(new Date).format('YYYY-MM-DD');

      this.dateRangeAdjust.startDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.dateRangeAdjust.endDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.dateRangeBonus.startDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.dateRangeBonus.endDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.dateRangeWinlose.startDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.dateRangeWinlose.endDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.dateRangeStatement.startDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.dateRangeStatement.endDate = this.$moment(new Date).format('YYYY-MM-DD');
      // this.clearInfo();
      this.getMemberSummary();
    },
    changedBankMbmStatus: function(item, eventStatus) {
      if (item.category == '' || item.category == null) {
        eventStatus.srcElement.checked = !item.status;
        item.status = !item.status;
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.invalidCategory"), "error");
        return;
      }

      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_bank_account_status_confirm", { name: item.bank_acc_no }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmBankMbmStatus(item, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.status;
            item.status = !item.status;
          }
        });
    },
    confirmBankMbmStatus: function(item, status) {
      let url = "";
      if (item.category == "BANK")
        url = config.bankMemberStatusUpdateUrl();
      else if (item.category == "EWALLET")
        url = config.bankMemberEWalletStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        member_id: this.search.trim(),
        bank_id: item.bank_id,
        bank_acc_no: item.bank_acc_no,
        new_status: status,
        audit_by: this.$store.getters.loginId
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                item.status = status;
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    setLoginIp: function (e) {
      this.selectedLoginIp = e;
      this.totalRowAudit = 0;
      this.auditLoginList = [];
      this.currentPageAudit = 1;
      this.getAuditLoginMemberList(true);
    },
    backToSummaryLvl() {
      this.pageLvlIp = "summary";
      this.totalRowAudit = 0;
      this.auditLoginList = [];
      this.currentPageAudit = 1;
      // this.clearTotalDetail();
    },
    showActionButton(action) {
      if (this.getAuthorityRole == 'SUB_PRI') {
        if (this.$store.getters.accountAuthority) {
          var roles = this.$store.getters.accountAuthority[0].authority_option;
          roles =  roles && roles.length > 0 ? roles.split(',') : [];
          if (roles.includes(action))
            return true;
          else
            return false;
        } else
          return false;
      } else {
        return true;
      }
    },
    sortOrder(key, type) {
      if (type == 'slots') {
        if (this.sortKeySlots == key) {
          // console.log(key, this.sortTypeSlots)
          this.sortTypeSlots = this.sortTypeSlots == 'asc' ? 'desc' : 'asc';
        }
        else {
          this.sortKeySlots = key;
          this.sortTypeSlots = 'asc';
        }

        this.getGameResultSlots(true);
      } else if (type == 'livecasino') {
        if (this.sortKeyLivecasino == key)
          this.sortTypeLivecasino = this.sortTypeLivecasino == 'asc' ? 'desc' : 'asc';
        else {
          this.sortKeyLivecasino = key;
          this.sortTypeLivecasino = 'asc';
        }

        this.getGameResultLivecasino(true);
      } else if (type == 'rebate') {
        if (this.sortKeyRebate == key)
          this.sortTypeRebate = this.sortTypeRebate == 'asc' ? 'desc' : 'asc';
        else {
          this.sortKeyRebate = key;
          this.sortTypeRebate = 'asc';
        }

        this.getGameResultRebate(true);
      } else if (type == 'sportsbook') {
        if (this.sortKeySportsbook == key)
          this.sortTypeSportsbook = this.sortTypeSportsbook == 'asc' ? 'desc' : 'asc';
        else {
          this.sortKeySportsbook = key;
          this.sortTypeSportsbook = 'asc';
        }

        this.getGameResultSportsbook(true);
      } else if (type == 'cockfight') {
        if (this.sortKeyCockfight == key)
          this.sortTypeCockfight = this.sortTypeCockfight == 'asc' ? 'desc' : 'asc';
        else {
          this.sortKeyCockfight = key;
          this.sortTypeCockfight = 'asc';
        }

        this.getGameResultCockfight(true);
      } else if (type == 'rescue') {
        if (this.sortKeyRescue == key)
          this.sortTypeRescue = this.sortTypeRescue == 'asc' ? 'desc' : 'asc';
        else {
          this.sortKeyRescue = key;
          this.sortTypeRescue = 'asc';
        }

        this.getGameResultRescue(true);
      } else if (type == 'adjust') {
        if (this.sortKeyAdjust == key)
          this.sortTypeAdjust = this.sortTypeAdjust == 'asc' ? 'desc' : 'asc';
        else {
          this.sortKeyAdjust = key;
          this.sortTypeAdjust = 'asc';
        }

        this.getAdjustmentList(true);
      } else if (type == 'bonus') {
        if (this.sortKeyBonus == key)
          this.sortTypeBonus = this.sortTypeBonus == 'asc' ? 'desc' : 'asc';
        else {
          this.sortKeyBonus = key;
          this.sortTypeBonus = 'asc';
        }

        this.getBonusList(true);
      } else if (type == 'winlose') {
        if (this.sortKeyWinlose == key)
          this.sortTypeWinlose = this.sortTypeWinlose == 'asc' ? 'desc' : 'asc';
        else {
          this.sortKeyWinlose = key;
          this.sortTypeWinlose = 'asc';
        }

        this.getProviderWinLose(true);
      } else if (type == 'statement') {
        if (this.sortKeyStatement == key)
          this.sortTypeStatement = this.sortTypeStatement == 'asc' ? 'desc' : 'asc';
        else {
          this.sortKeyStatement = key;
          this.sortTypeStatement = 'asc';
        }

        this.getStatement(true);
      }
    },
    changeSortKey(key, type) {
      if (type == 'slots') {
        if (this.sortKeySlots != key)
          return 'fas fa-sort';
        else if (this.sortKeySlots == key && this.sortTypeSlots == 'asc')
          return 'fa fa-sort-up';
        else if (this.sortKeySlots == key && this.sortTypeSlots == 'desc')
          return 'fa fa-sort-down';
      } else if (type == 'livecasino') {
        if (this.sortKeyLivecasino != key)
          return 'fas fa-sort';
        else if (this.sortKeyLivecasino == key && this.sortTypeLivecasino == 'asc')
          return 'fa fa-sort-up';
        else if (this.sortKeyLivecasino == key && this.sortTypeLivecasino == 'desc')
          return 'fa fa-sort-down';
      } else if (type == 'rebate') {
        if (this.sortKeyRebate != key)
          return 'fas fa-sort';
        else if (this.sortKeyRebate == key && this.sortTypeRebate == 'asc')
          return 'fa fa-sort-up';
        else if (this.sortKeyRebate == key && this.sortTypeRebate == 'desc')
          return 'fa fa-sort-down';
      } else if (type == 'sportsbook') {
        if (this.sortKeySportsbook != key)
          return 'fas fa-sort';
        else if (this.sortKeySportsbook == key && this.sortTypeSportsbook == 'asc')
          return 'fa fa-sort-up';
        else if (this.sortKeySportsbook == key && this.sortTypeSportsbook == 'desc')
          return 'fa fa-sort-down';
      } else if (type == 'cockfight') {
        if (this.sortKeyCockfight != key)
          return 'fas fa-sort';
        else if (this.sortKeyCockfight == key && this.sortTypeCockfight == 'asc')
          return 'fa fa-sort-up';
        else if (this.sortKeyCockfight == key && this.sortTypeCockfight == 'desc')
          return 'fa fa-sort-down';
      } else if (type == 'rescue') {
        if (this.sortKeyRescue != key)
          return 'fas fa-sort';
        else if (this.sortKeyRescue == key && this.sortTypeRescue == 'asc')
          return 'fa fa-sort-up';
        else if (this.sortKeyRescue == key && this.sortTypeRescue == 'desc')
          return 'fa fa-sort-down';
      } else if (type == 'adjust') {
        if (this.sortKeyAdjust != key)
          return 'fas fa-sort';
        else if (this.sortKeyAdjust == key && this.sortTypeAdjust == 'asc')
          return 'fa fa-sort-up';
        else if (this.sortKeyAdjust == key && this.sortTypeAdjust == 'desc')
          return 'fa fa-sort-down';
      } else if (type == 'bonus') {
        if (this.sortKeyBonus != key)
          return 'fas fa-sort';
        else if (this.sortKeyBonus == key && this.sortTypeBonus == 'asc')
          return 'fa fa-sort-up';
        else if (this.sortKeyBonus == key && this.sortTypeBonus == 'desc')
          return 'fa fa-sort-down';
      } else if (type == 'winlose') {
        if (this.sortKeyWinlose != key)
          return 'fas fa-sort';
        else if (this.sortKeyWinlose == key && this.sortTypeWinlose == 'asc')
          return 'fa fa-sort-up';
        else if (this.sortKeyWinlose == key && this.sortTypeWinlose == 'desc')
          return 'fa fa-sort-down';
      } else if (type == 'statement') {
        if (this.sortKeyStatement != key)
          return 'fas fa-sort';
        else if (this.sortKeyStatement == key && this.sortTypeStatement == 'asc')
          return 'fa fa-sort-up';
        else if (this.sortKeyStatement == key && this.sortTypeStatement == 'desc')
          return 'fa fa-sort-down';
      }
    },
    redirectToRL: function(item) {
      var json = { referral_code: item.referral_code };
      this.$store.dispatch("user/setRefereeListParam", json);
      this.$router.push("/report/refereeList");
    },
    onPromoSignupAssign: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.free_credit"),
          text: this.$t("message.assign_free_credit_confirm", { name: item.account_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmPromoSignupAssign(item);
          }
        });
    },
    confirmPromoSignupAssign: function(item) {
      let url = config.promotionSignupAssignUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        member_id: item.account_id,
        audit_by: this.$store.getters.loginId
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getMemberSummary();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedReferralStatus: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_referral_status_confirm", { name: item.account_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmReferralStatus(item, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.status;
            item.referral_status = !item.referral_status;
          }
        });
    },
    confirmReferralStatus: function(item, status) {
      let url = config.memberStatusUpdateReferralUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        member_id: item.account_id,
        new_status: status,
        audit_by: this.$store.getters.loginId
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                // item.status = status;
                this.getMemberSummary();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getResultDetail(e) {
      this.getResultDetailAPI(e);
    },
    getResultDetailAPI: function(item) {
      let url = "";
      var json = {
        player_id: item.member_id,
        ticket_id: item.result_id,
        lang_code: "en"
      };

      this.resultDetailUrl = "";
      if (item.result_id.startsWith('OSG_')) this.resultDetailUrl = config.resultDetail["epicUrl"] + item.result_id
      else if (item.result_id.startsWith('LIVE22_')) url = config.resultDetail["live22Url"];
      else if (item.result_id.startsWith('FASTSPIN_')) url = config.resultDetail["awcUrl"];
      else if (item.result_id.startsWith('FC_')) url = config.resultDetail["fcUrl"];
      else if (item.result_id.startsWith('JDB_')) url = config.resultDetail["awcUrl"];
      else if (item.result_id.startsWith('JILI_')) url = config.resultDetail["awcUrl"];
      else if (item.result_id.startsWith('PG_')) url = config.resultDetail["awcUrl"];
      else if (item.result_id.startsWith('SEXYBCRT_')) url = config.resultDetail["awcUrl"];
      else if (item.result_id.startsWith('VENUS_')) url = config.resultDetail["awcUrl"];
      else if (item.result_id.startsWith('YESBINGO_')) url = config.resultDetail["awcUrl"];
      else if (item.result_id.startsWith('YL_')) url = config.resultDetail["awcUrl"];
      else if (item.result_id.startsWith('EVO_')) url = config.resultDetail["evoUrl"];
      else if (item.result_id.startsWith('JILI2_')) url = config.resultDetail["jili2Url"];
      else if (item.result_id.startsWith('EPIC2_')) url = config.resultDetail["epic2Url"];
      else if (item.result_id.startsWith('HBNR_')) url = config.resultDetail["habaneroUrl"];
      else if (item.result_id.startsWith('PP-S_')) url = config.resultDetail["ppsUrl"];
      else if (item.result_id.startsWith('MG_')) url = config.resultDetail["oneUrl"];
      else if (item.result_id.startsWith('SPNX_')) url = config.resultDetail["oneUrl"];
      else if (item.result_id.startsWith('SPDG_')) url = config.resultDetail["oneUrl"];
      else if (item.result_id.startsWith('BG_')) url = config.resultDetail["oneUrl"];
      else if (item.result_id.startsWith('HSG_')) url = config.resultDetail["oneUrl"];
      else if (item.result_id.startsWith('RG_')) url = config.resultDetail["oneUrl"];
      else if (item.result_id.startsWith('EVOP_')) url = config.resultDetail["oneUrl"];
      else if (item.result_id.startsWith('PNG_')) url = config.resultDetail["oneUrl"];
      else if (item.result_id.startsWith('EVONTT_')) url = config.resultDetail["oneUrl"];
      else if (item.result_id.startsWith('EVORT_')) url = config.resultDetail["oneUrl"];
      else if (item.result_id.startsWith('EVOBTG_')) url = config.resultDetail["oneUrl"];
      else if (item.result_id.startsWith('EVONLC_')) url = config.resultDetail["oneUrl"];
      else if (item.result_id.startsWith('BNG_')) url = config.resultDetail["oneUrl"];
      else if (item.result_id.startsWith('AP_')) url = config.resultDetail["oneUrl"];
      else if (item.result_id.startsWith('ALG_')) url = config.resultDetail["oneUrl"];
      else if (item.result_id.startsWith('SPB_')) url = config.resultDetail["oneUrl"];
      else if (item.result_id.startsWith('WIFY_')) url = config.resultDetail["oneUrl"];
      else if (item.result_id.startsWith('YB_')) url = config.resultDetail["oneUrl"];
      else if (item.result_id.startsWith('BG-S_')) url = config.resultDetail["oneUrl"];
      else if (item.result_id.startsWith('CQ9_')) url = config.resultDetail["cq9Url"];
      else if (item.result_id.startsWith('PP-S123_')) url = config.resultDetail["pps123Url"];
      else if (item.result_id.startsWith('YGR_')) url = config.resultDetail["ygrUrl"];
      else if (item.result_id.startsWith('HSD_')) url = config.resultDetail["oneUrl"];
      else if (item.result_id.startsWith('MEGAH5_')) url = config.resultDetail["megah5Url"];
      else if (item.result_id.startsWith('WOW_')) url = config.resultDetail["wowUrl"];
      else if (item.result_id.startsWith('TBL_')) {
        this.resultDetailUrl = config.resultDetail["tblUrl"].toString().replace('{0}',this.$store.getters.loginId);
        this.resultDetailUrl = this.resultDetailUrl.replace('{1}',this.$store.getters.sessionToken);
        this.resultDetailUrl = this.resultDetailUrl.replace('{2}',item.result_id);
      }

      if (url != "") {
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (response.data.detail_url != null && response.data.detail_url != "") {
                  this.feedback.success = true;
                  this.feedback.status = "OK";
                  this.resultDetailUrl = response.data.detail_url;
                }
                else {
                  this.feedback.success = false;
                  if (response.data.status_desc) {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), response.data.status_desc, "error");
                  }
                  else {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.failedToGetResultUrl"), "error");
                  }
                  // this.feedback.status = (response.data.status_desc ? response.data.status_desc : "failedToGetResultUrl");
                  // if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }

                if (this.resultDetailUrl != "" && this.feedback.success == true)
                  window.open(this.resultDetailUrl, "info", "toolbar=no,scrollbars=no,resizable=no,top=0,left=0,width=480,height=640");
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        if (this.resultDetailUrl != "")
          window.open(this.resultDetailUrl, "info", "toolbar=no,scrollbars=no,resizable=no,top=0,left=0,width=480,height=640");
      }
    },
    onEdit(e) {
      this.editSelectedMember = e;
      this.$refs.editmember.$refs.editMember.show();
    },
    onAdjust(e) {
      this.editSelectedMember = e;
      this.$refs.adjustmember.$refs.adjustMember.show();
    },
    onResetPasswordMember(e) {
      this.editSelectedMember = e;
      this.$refs.resetpasswordmember.$refs.resetPasswordMember.show();
    },
    onGetTac(e) {
      this.editSelectedMember = e;
      this.$refs.gettac.$refs.getTac.show();
    },
    onGetBankTac(e) {
      this.editSelectedMember = e;
      this.$refs.getbanktac.$refs.getBankTac.show();
    },
    onRaiseDepositTicket(e) {
      this.editSelectedMember = e;
      this.$refs.raisedepositticket.$refs.raiseDepositTicket.show();
    },
    onBonusIssue(e) {
      this.editSelectedMember = e;
      this.$refs.bonusissue.$refs.bonusIssue.show();
    },
    onPromoMemberAssign(e) {
      this.editSelectedMember = e;
      this.$refs.promomemberassign.$refs.promoMemberAssign.show();
    },
    onUpdateVip(e) {
      this.editSelectedMember = e;
      this.$refs.updatevip.$refs.updateVip.show();
    },
    onUpdateMemberProfile(e) {
      this.editSelectedMember = e;
      this.$refs.updatememberprofile.$refs.updateMemberProfile.show();
    },
    onUpdateMemberBetLimit(e) {
      this.editSelectedMember = e;
      this.$refs.updatememberbetlimit.$refs.updateMemberBetLimit.show();
    },
    onGetInbox(e) {
      this.editSelectedMember = e;
      this.$refs.getinboxlist.$refs.getInboxList.show();
    },
    onGetRebate(e) {
      this.editSelectedMember = e;
      this.$refs.getrebate.$refs.getRebate.show();
    },
    onInfo(e) {
      this.editSelectedMember = e;
      this.$refs.membersummary.$refs.memberSummary.show();
    },
    onIssueFreeSpin(e) {
      this.editSelectedMember = e;
      this.$refs.issuefreespin.$refs.issueFreeSpin.show();
    },
    onCheckMemberFreeSpin(e) {
      this.editSelectedMember = e;
      this.$refs.checkmemberfreespin.$refs.checkMemberFreeSpin.show();
    },
    onClearOutstanding(e) {
      this.editSelectedMember = e;
      this.$refs.clearoutstanding.$refs.clearOutstanding.show();
    },
    onRaiseDepositTicketGateway(e) {
      this.editSelectedMember = e;
      this.$refs.raisedepositticketgateway.$refs.raiseDepositTicketGateway.show();
    },
    onUpsertLabel(e) {
      this.editSelectedMember = e;
      this.$refs.upsertlabel.$refs.upsertLabel.show();
    },
    getDataSlots(currentValue) {
      this.dateRangeSlots.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD HH:mm:ss');
      this.dateRangeSlots.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD HH:mm:ss');
      this.getGameResultSlots(true);
    },
    checkDateRangeSlots() {
      if (this.$moment(this.dateRangeSlots.endDate).diff(this.$moment(this.dateRangeSlots.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getDataLivecasino(currentValue) {
      this.dateRangeLivecasino.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD HH:mm:ss');
      this.dateRangeLivecasino.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD HH:mm:ss');
      this.getGameResultLivecasino(true);
    },
    checkDateRangeLivecasino() {
      if (this.$moment(this.dateRangeLivecasino.endDate).diff(this.$moment(this.dateRangeLivecasino.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getDataRebate(currentValue) {
      this.dateRangeRebate.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRangeRebate.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getGameResultRebate(true);
    },
    checkDateRangeRebate() {
      if (this.$moment(this.dateRangeRebate.endDate).diff(this.$moment(this.dateRangeRebate.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    onOffDetail(item) {
      if (this.isShowDetail == true) {
        if (this.currId == item.result_id) {
          this.isShowDetail = false;
          this.currId = null;
        } else {
          this.isShowDetail = false;
          this.currId = null;
          this.isShowDetail = true;
          this.currId = item.result_id;
        }
      } else {
        this.isShowDetail = true;
        this.currId = item.result_id;
      }
    },
    getOddsType(n) {
      var result = "";
      switch(n) {
        case 1:
          result = "(MY)";
          break;
        case 2:
          result = "(HK)";
          break;
        case 3:
          result = "(ID)";
          break;
        case 4:
          result = "(DEC)";
          break;
      }
      return result;
    },
    checkDateRangeSportsbook() {
      if (this.$moment(this.dateRangeSportsbook.endDate).diff(this.$moment(this.dateRangeSportsbook.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getDataSportsbook(currentValue) {
      this.dateRangeSportsbook.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRangeSportsbook.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getGameResultSportsbook(true);
    },
    checkDateRangeCockfight() {
      if (this.$moment(this.dateRangeCockfight.endDate).diff(this.$moment(this.dateRangeCockfight.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getDataCockfight(currentValue) {
      this.dateRangeCockfight.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD HH:mm:ss');
      this.dateRangeCockfight.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD HH:mm:ss');
      this.getGameResultCockfight(true);
    },
    checkDateRangeRescue() {
      if (this.$moment(this.dateRangeRescue.endDate).diff(this.$moment(this.dateRangeRescue.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getDataRescue(currentValue) {
      this.dateRangeRescue.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRangeRescue.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getGameResultRescue(true);
    },
    checkDateRangeAdjust() {
      if (this.$moment(this.dateRangeAdjust.endDate).diff(this.$moment(this.dateRangeAdjust.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getDataAdjust(currentValue) {
      this.dateRangeAdjust.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRangeAdjust.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getAdjustmentList(true);
    },
    checkDateRangeBonus() {
      if (this.$moment(this.dateRangeBonus.endDate).diff(this.$moment(this.dateRangeBonus.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getDataBonus(currentValue) {
      this.dateRangeBonus.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRangeBonus.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getBonusList(true);
    },
    checkDateRangeWinlose() {
      if (this.$moment(this.dateRangeWinlose.endDate).diff(this.$moment(this.dateRangeWinlose.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getDataWinlose(currentValue) {
      this.dateRangeWinlose.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRangeWinlose.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getProviderWinLose(true);
    },
    checkDateRangeStatement() {
      if (this.$moment(this.dateRangeStatement.endDate).diff(this.$moment(this.dateRangeStatement.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getDataStatement(currentValue) {
      this.dateRangeStatement.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRangeStatement.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getStatement(true);
    },
    clearInfo() {
      // this.dateRangeSlots.startDate = this.$moment(new Date).format('YYYY-MM-DD 00:00:00');
      // this.dateRangeSlots.endDate = this.$moment(new Date).format('YYYY-MM-DD 23:59:59');
      // this.dateRangeLivecasino.startDate = this.$moment(new Date).format('YYYY-MM-DD 00:00:00');
      // this.dateRangeLivecasino.endDate = this.$moment(new Date).format('YYYY-MM-DD 23:59:59');
      // this.dateRangeRebate.startDate = this.$moment(new Date).format('YYYY-MM-DD');
      // this.dateRangeRebate.endDate = this.$moment(new Date).format('YYYY-MM-DD');
      // this.dateRangeSportsbook.startDate = this.$moment(new Date).format('YYYY-MM-DD');
      // this.dateRangeSportsbook.endDate = this.$moment(new Date).format('YYYY-MM-DD');
      // this.dateRangeCockfight.startDate = this.$moment(new Date).format('YYYY-MM-DD 00:00:00');
      // this.dateRangeCockfight.endDate = this.$moment(new Date).format('YYYY-MM-DD 23:59:59');
      // this.dateRangeRescue.startDate = this.$moment(new Date).format('YYYY-MM-DD');
      // this.dateRangeRescue.endDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.mbmFound = false;
      this.editSelectedMember = null;
      this.loginList = [];
      this.depositList = [];
      this.withdrawalList = [];
      this.validTurnover = null;
      this.winlose = null;
      this.wallet = null;
      this.member = null;
      this.ftd = null;
      this.bonusAmount = 0;
      this.promoID = "";
      this.promoName = "";
      this.promoAccumulate = 0;
      this.promoTarget = 0;
      this.promoCriteria = "";
      this.promoDate = null;
      this.ftdAmount = 0;
      this.ftdDate = null;
      this.info = null;
      this.bankList = [];
      this.ipList = [];
      this.auditLoginList = [];
      this.labelList = [];
      this.memberLabel = null;
      this.currentVip = "";
      this.nextVip = "";
      this.possibleNextVip = "";
      this.vipDepositAcc = 0;
      this.vipDepositTarget = 0;
      this.vipTurnoverAcc = 0;
      this.vipTurnoverTarget = 0;
      this.rewardTypeNext = "";
      this.cashNext = 0;
      this.csNext = "";
      this.spNext = "";
      this.lastCycle = null;
      this.nextCycle = null;
      this.rebateType = "";
      this.rescueType = "";
      this.clearTotalSlots()
      this.clearTotalLivecasino()
      this.clearTotalRebate()
      this.clearTotalSportsbook()
      this.clearTotalCockfight()
      this.clearTotalRescue()
      this.clearTotalAdjust()
      this.clearTotalWinlose()
      this.clearTotalStatement()
      this.clearTotalBonus()
    },
    getMemberSummary: function() {
      let url = config.memberSummaryV2Url();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.memberId,
        working_month: this.$moment(new Date).startOf("month").format("YYYY-MM-DD")
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.mbmFound = true;
          this.clearInfo()
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.info = response.data.ds;
                if (this.info != null) {
                  if (response.data.ds.summary) {
                  if(response.data.ds.summary.length > 0) {
                      this.validTurnover = response.data.ds.summary[0].valid_turnover;
                      this.winlose = response.data.ds.summary[0].winlose;
                    }
                  }

                  if(response.data.ds.deposit)
                    this.depositList = response.data.ds.deposit;

                  if (response.data.ds.withdrawal)
                    this.withdrawalList = response.data.ds.withdrawal;

                  if (response.data.ds.login)
                    this.loginList = response.data.ds.login;

                  if (response.data.ds.details) {
                    if (response.data.ds.details.length > 0)
                      this.member = response.data.ds.details[0];
                  }

                  if (response.data.ds.wallet) {
                    if (response.data.ds.wallet.length > 0)
                      this.wallet = response.data.ds.wallet[0];
                  }

                  if (response.data.ds.ftd) {
                    if (response.data.ds.ftd.length > 0)
                      this.ftd = response.data.ds.ftd[0];
                      if (this.ftd != null) {
                        this.ftdAmount = this.ftd.ftd_amount;
                        this.ftdDate = this.ftd.ftd_date;
                      }
                  }

                  if (response.data.ds.promo) {
                    if(response.data.ds.promo.length > 0) {
                      var promoType = response.data.ds.promo[0].a;
                      if (promoType == "TURNOVER") {
                        this.promoAccumulate = response.data.ds.promo[0].d;
                        this.promoTarget = response.data.ds.promo[0].b;
                        this.promoID = response.data.ds.promo[0].e;
                        this.promoName = response.data.ds.promo[0].g;
                        this.bonusAmount = response.data.ds.promo[0].h;
                        this.promoDate = response.data.ds.promo[0].i;
                        this.promoCriteria = promoType;
                      } else if (promoType == "WIN") {
                        this.promoAccumulate = response.data.ds.promo[0].c;
                        this.promoTarget = response.data.ds.promo[0].b;
                        this.promoID = response.data.ds.promo[0].e;
                        this.promoName = response.data.ds.promo[0].g;
                        this.bonusAmount = response.data.ds.promo[0].h;
                        this.promoDate = response.data.ds.promo[0].i;
                        this.promoCriteria = promoType;
                      }
                    }
                  }

                  if (response.data.ds.bank)
                    this.bankList = response.data.ds.bank;

                  if (response.data.ds.label) {
                    this.labelList = response.data.ds.label;
                    var arr = [];
                    response.data.ds.label.forEach(value => {
                      arr.push(value["label_name"]);
                    });

                    this.memberLabel = arr.toString();
                  }

                  if (response.data.ds.vip) {
                    if(response.data.ds.vip.length > 0) {
                      if (response.data.ds.vip[0].deposit_next) {
                        var cycle_deposit = response.data.ds.vip[0].cycle_deposit ? response.data.ds.vip[0].cycle_deposit : 0;
                        var starting_deposit = response.data.ds.vip[0].starting_deposit ? response.data.ds.vip[0].starting_deposit : 0;
                        this.vipDepositAcc = cycle_deposit + starting_deposit;
                        this.vipDepositTarget = response.data.ds.vip[0].deposit_next ? response.data.ds.vip[0].deposit_next : 0;
                      }

                      if (response.data.ds.vip[0].turnover_next) {
                        var cycle_turnover = response.data.ds.vip[0].cycle_turnover ? response.data.ds.vip[0].cycle_turnover : 0;
                        var starting_turnover = response.data.ds.vip[0].starting_turnover ? response.data.ds.vip[0].starting_turnover : 0;
                        this.vipTurnoverAcc = cycle_turnover + starting_turnover;
                        this.vipTurnoverTarget = response.data.ds.vip[0].turnover_next ? response.data.ds.vip[0].turnover_next : 0;
                      }

                      this.currentVip = response.data.ds.vip[0].vip_name;
                      this.nextVip = response.data.ds.vip[0].vip_name_next;
                      this.possibleNextVip = response.data.ds.vip[0].possible_vip_name_next;
                      // this.rewardTypeNext = response.data.ds.vip[0].reward_type_next;
                      // this.cashNext = response.data.ds.vip[0].cash_next;
                      // this.csNext = response.data.ds.vip[0].cs_next;
                      // this.spNext = response.data.ds.vip[0].social_platform_next;
                      this.lastCycle = response.data.ds.vip[0].last_cycle;
                      this.nextCycle = response.data.ds.vip[0].next_cycle;
                    }
                  }
                }
                else {
                  this.clearInfo()
                }
              } else {
                this.clearInfo()
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getGameResultSlots: function(isSearch) {
      if (this.checkDateRangeSlots()) {
        let url = config.gameResultSlotsUrl();

        if (isSearch) this.currentPageSlots = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          account_id: this.member.account_id,
          provider_code: this.providerSlots,
          start_date: this.dateRangeSlots.startDate,
          end_date: this.dateRangeSlots.endDate,
          sort_key: this.sortKeySlots,
          sort_type: this.sortTypeSlots,
          page_number: this.currentPageSlots,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotalSlots()
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.ds.gameresult.length > 0) {
                    this.showTotalSlots = true
                    response.data.ds.gameresult.forEach(value => {
                      this.subTotalTurnoverSlots = parseFloat(this.subTotalTurnoverSlots) + parseFloat(value["turnover"]);
                      this.subTotalValidTurnoverSlots = parseFloat(this.subTotalValidTurnoverSlots) + parseFloat(value["valid_turnover"]);
                      this.subTotalWinLoseSlots = parseFloat(this.subTotalWinLoseSlots) + parseFloat(value["winlose"]);
                      this.subTotalPayoutSlots = parseFloat(this.subTotalPayoutSlots) + parseFloat(value["payout"]);
                    });

                    if(response.data.ds.grand_total.length > 0) {
                      this.grandTotalTurnoverSlots = response.data.ds.grand_total[0]["turnover"];
                      this.grandTotalValidTurnoverSlots = response.data.ds.grand_total[0]["valid_turnover"];
                      this.grandTotalWinLoseSlots = response.data.ds.grand_total[0]["winlose"];
                      this.grandTotalPayoutSlots = response.data.ds.grand_total[0]["payout"];
                    }

                    this.slotsList = response.data.ds.gameresult;
                    this.totalRowSlots = response.data.ds.gameresult.length > 0 ? this.slotsList[0]["totalrows"] : 0
                  } else {
                    this.clearTotalSlots()
                  }
                } else {
                  this.clearTotalSlots()
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.clearTotalSlots();
        this.slotsList = [];
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getGameResultLivecasino: function(isSearch) {
      if (this.checkDateRangeLivecasino()) {

        let url = config.gameResultLivecasinoUrl();

        if (isSearch) this.currentPageLivecasino = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          account_id: this.member.account_id,
          provider_code: this.providerLivecasino,
          table_id: this.tableIdLivecasino,
          start_date: this.dateRangeLivecasino.startDate,
          end_date: this.dateRangeLivecasino.endDate,
          sort_key: this.sortKeyLivecasino,
          sort_type: this.sortTypeLivecasino,
          page_number: this.currentPageLivecasino,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotalLivecasino()
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.ds.gameresult.length > 0) {
                    this.showTotalLivecasino = true
                    response.data.ds.gameresult.forEach(value => {
                      this.subTotalTurnoverLivecasino = parseFloat(this.subTotalTurnoverLivecasino) + parseFloat(value["turnover"]);
                      this.subTotalValidTurnoverLivecasino = parseFloat(this.subTotalValidTurnoverLivecasino) + parseFloat(value["valid_turnover"]);
                      this.subTotalWinLoseLivecasino = parseFloat(this.subTotalWinLoseLivecasino) + parseFloat(value["winlose"]);
                      this.subTotalPayoutLivecasino = parseFloat(this.subTotalPayoutLivecasino) + parseFloat(value["payout"]);
                    });

                    if(response.data.ds.grand_total.length > 0) {
                      this.grandTotalTurnoverLivecasino = response.data.ds.grand_total[0]["turnover"];
                      this.grandTotalValidTurnoverLivecasino = response.data.ds.grand_total[0]["valid_turnover"];
                      this.grandTotalWinLoseLivecasino = response.data.ds.grand_total[0]["winlose"];
                      this.grandTotalPayoutLivecasino = response.data.ds.grand_total[0]["payout"];
                    }

                    this.livecasinoList = response.data.ds.gameresult;
                    this.totalRowLivecasino = response.data.ds.gameresult.length > 0 ? this.livecasinoList[0]["totalrows"] : 0
                  } else {
                    this.clearTotalLivecasino()
                  }
                } else {
                  this.clearTotalLivecasino()
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.clearTotalLivecasino();
        this.livecasinoList = [];
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getGameResultRebate: function(isSearch) {
      if (this.checkDateRangeRebate()) {
        let url = config.gameResultRebateUrl();

        if (isSearch) this.currentPageRebate = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          account_id: this.member.account_id,
          start_date: this.dateRangeRebate.startDate,
          end_date: this.dateRangeRebate.endDate,
          game_type: this.rebateType == "" ? null : this.rebateType,
          sort_key: this.sortKeyRebate,
          sort_type: this.sortTypeRebate,
          page_number: this.currentPageRebate,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotalRebate()
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.ds.gameresult.length > 0) {
                    this.showTotalRebate = true
                    response.data.ds.gameresult.forEach(value => {
                      this.subTotalTurnoverRebate = parseFloat(this.subTotalTurnoverRebate) + parseFloat(value["turnover"]);
                      this.subTotalValidTurnoverRebate = parseFloat(this.subTotalValidTurnoverRebate) + parseFloat(value["valid_turnover"]);
                      this.subTotalWinLoseRebate = parseFloat(this.subTotalWinLoseRebate) + parseFloat(value["winlose"]);
                      this.subTotalPayoutRebate = parseFloat(this.subTotalPayoutRebate) + parseFloat(value["payout"]);
                    });

                    if(response.data.ds.grand_total.length > 0) {
                      this.grandTotalTurnoverRebate = response.data.ds.grand_total[0]["turnover"];
                      this.grandTotalValidTurnoverRebate = response.data.ds.grand_total[0]["valid_turnover"];
                      this.grandTotalWinLoseRebate = response.data.ds.grand_total[0]["winlose"];
                      this.grandTotalPayoutRebate = response.data.ds.grand_total[0]["payout"];
                    }

                    this.rebateList = response.data.ds.gameresult;
                    this.totalRowRebate = response.data.ds.gameresult.length > 0 ? this.rebateList[0]["totalrows"] : 0
                  } else {
                    this.clearTotalRebate()
                  }
                } else {
                  this.clearTotalRebate()
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.clearTotalRebate();
        this.rebateList = [];
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getGameResultSportsbook: function(isSearch) {
      if (this.checkDateRangeSportsbook()) {
        let url = config.gameResultSportsbookUrl();

        if (isSearch) this.currentPageSportsbook = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          account_id: this.member.account_id,
          start_date: this.dateRangeSportsbook.startDate,
          end_date: this.dateRangeSportsbook.endDate,
          sort_key: this.sortKeySportsbook,
          sort_type: this.sortTypeSportsbook,
          page_number: this.currentPageSportsbook,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotalSportsbook()
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.ds.gameresult.length > 0) {
                    this.showTotalSportsbook = true
                    response.data.ds.gameresult.forEach(value => {
                      this.subTotalTurnoverSportsbook = parseFloat(this.subTotalTurnoverSportsbook) + parseFloat(value["turnover"]);
                      this.subTotalValidTurnoverSportsbook = parseFloat(this.subTotalValidTurnoverSportsbook) + parseFloat(value["valid_turnover"]);
                      this.subTotalWinLoseSportsbook = parseFloat(this.subTotalWinLoseSportsbook) + parseFloat(value["winlose"]);
                      this.subTotalPayoutSportsbook = parseFloat(this.subTotalPayoutSportsbook) + parseFloat(value["payout"]);
                    });

                    if(response.data.ds.grand_total.length > 0) {
                      this.grandTotalTurnoverSportsbook = response.data.ds.grand_total[0]["turnover"];
                      this.grandTotalValidTurnoverSportsbook = response.data.ds.grand_total[0]["valid_turnover"];
                      this.grandTotalWinLoseSportsbook = response.data.ds.grand_total[0]["winlose"];
                      this.grandTotalPayoutSportsbook = response.data.ds.grand_total[0]["payout"];
                    }

                    this.sportsbookList = response.data.ds.gameresult;
                    this.totalRowSportsbook = response.data.ds.gameresult.length > 0 ? this.sportsbookList[0]["totalrows"] : 0
                  } else {
                    this.clearTotalSportsbook()
                  }
                } else {
                  this.clearTotalSportsbook()
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.clearTotalSportsbook();
        this.sportsbookList = [];
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getGameResultCockfight: function(isSearch) {
      if (this.checkDateRangeCockfight()) {
        let url = config.gameResultCockfightUrl();

        if (isSearch) this.currentPageCockfight = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          account_id: this.member.account_id,
          start_date: this.dateRangeCockfight.startDate,
          end_date: this.dateRangeCockfight.endDate,
          sort_key: this.sortKeyCockfight,
          sort_type: this.sortTypeCockfight,
          page_number: this.currentPageCockfight,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotalCockfight()
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.ds.gameresult.length > 0) {
                    this.showTotalCockfight = true
                    response.data.ds.gameresult.forEach(value => {
                      this.subTotalTurnoverCockfight = parseFloat(this.subTotalTurnoverCockfight) + parseFloat(value["turnover"]);
                      this.subTotalValidTurnoverCockfight = parseFloat(this.subTotalValidTurnoverCockfight) + parseFloat(value["valid_turnover"]);
                      this.subTotalWinLoseCockfight = parseFloat(this.subTotalWinLoseCockfight) + parseFloat(value["winlose"]);
                      this.subTotalPayoutCockfight = parseFloat(this.subTotalPayoutCockfight) + parseFloat(value["payout"]);
                    });

                    if(response.data.ds.grand_total.length > 0) {
                      this.grandTotalTurnoverCockfight = response.data.ds.grand_total[0]["turnover"];
                      this.grandTotalValidTurnoverCockfight = response.data.ds.grand_total[0]["valid_turnover"];
                      this.grandTotalWinLoseCockfight = response.data.ds.grand_total[0]["winlose"];
                      this.grandTotalPayoutCockfight = response.data.ds.grand_total[0]["payout"];
                    }

                    this.cockfightList = response.data.ds.gameresult;
                    this.totalRowCockfight = response.data.ds.gameresult.length > 0 ? this.cockfightList[0]["totalrows"] : 0
                  } else {
                    this.clearTotalCockfight()
                  }
                } else {
                  this.clearTotalCockfight()
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.clearTotalCockfight();
        this.cockfightList = [];
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getGameResultRescue: function(isSearch) {
      if (this.checkDateRangeRescue()) {
        let url = config.gameResultRescueUrl();

        if (isSearch) this.currentPageRescue = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          account_id: this.member.account_id,
          start_date: this.dateRangeRescue.startDate,
          end_date: this.dateRangeRescue.endDate,
          game_type: this.rescueType == "" ? null : this.rescueType,
          sort_key: this.sortKeyRescue,
          sort_type: this.sortTypeRescue,
          page_number: this.currentPageRescue,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotalRescue()
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.ds.gameresult.length > 0) {
                    this.showTotalRescue = true
                    response.data.ds.gameresult.forEach(value => {
                      this.subTotalTurnoverRescue = parseFloat(this.subTotalTurnoverRescue) + parseFloat(value["turnover"]);
                      this.subTotalValidTurnoverRescue = parseFloat(this.subTotalValidTurnoverRescue) + parseFloat(value["valid_turnover"]);
                      this.subTotalWinLoseRescue = parseFloat(this.subTotalWinLoseRescue) + parseFloat(value["winlose"]);
                      this.subTotalPayoutRescue = parseFloat(this.subTotalPayoutRescue) + parseFloat(value["payout"]);
                    });

                    if(response.data.ds.grand_total.length > 0) {
                      this.grandTotalTurnoverRescue = response.data.ds.grand_total[0]["turnover"];
                      this.grandTotalValidTurnoverRescue = response.data.ds.grand_total[0]["valid_turnover"];
                      this.grandTotalWinLoseRescue = response.data.ds.grand_total[0]["winlose"];
                      this.grandTotalPayoutRescue = response.data.ds.grand_total[0]["payout"];
                    }

                    this.rescueList = response.data.ds.gameresult;
                    this.totalRowRescue = response.data.ds.gameresult.length > 0 ? this.rescueList[0]["totalrows"] : 0
                  } else {
                    this.clearTotalRescue()
                  }
                } else {
                  this.clearTotalRescue()
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.clearTotalRescue();
        this.rescueList = [];
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getIpAssociateList: function(isSearch) {
      let url = config.ipAssociateListUrl();

      if (isSearch) this.currentPageIp = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        member_id: this.search.trim(),
        search_id: this.searchIp,
        sort_key: this.sortKeyIp,
        sort_type: this.sortTypeIp,
        page_number: this.currentPageIp,
        page_size: this.getPageSize
      };

      this.pageLvlIp = 'summary';

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.ipList = response.data.dt;
                this.totalRowIp = this.ipList.length > 0 ? this.ipList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getAuditLoginMemberList: function(isSearch) {
      let url = config.auditLoginMemberV2Url();

      if (isSearch) this.currentPageAudit = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        member_id: this.selectedLoginIp.action_by,
        login_ip: this.selectedLoginIp.login_ip,
        sort_key: this.sortKeyAudit,
        sort_type: this.sortTypeAudit,
        page_number: this.currentPageAudit,
        page_size: this.getPageSize
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.pageLvlIp = 'detail';
                this.auditLoginList = response.data.dt;
                this.totalRowAudit = this.auditLoginList.length > 0 ? this.auditLoginList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getAdjustmentList: function(isSearch) {
      if (this.checkDateRangeAdjust()) {

        let url = config.adjustmentListUrl();

        if (isSearch) this.currentPageAdjust = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          account_id: this.$store.getters.accountId,
          is_sb: this.signupBonus,
          filter_amount: this.filterAmount,
          start_date: this.dateRangeAdjust.startDate,
          end_date: this.dateRangeAdjust.endDate,
          sort_key: this.sortKeyAdjust,
          sort_type: this.sortTypeAdjust,
          page_number: this.currentPageAdjust,
          page_size: this.getPageSize,
          member_id: this.member.account_id
        };

        // if (this.searchAdjust.trim() != '')
        //   json.member_id = this.searchAdjust;

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotalAdjust()
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.dt.length > 0) {
                    this.showTotalAdjust = true;
                    response.data.dt.forEach(value => {
                      this.subTotalAmountAdjust = parseFloat(this.subTotalAmountAdjust) + parseFloat(value["amount"]);
                    });

                    this.adjustmentList = response.data.dt;
                    this.totalRowAdjust = this.adjustmentList.length > 0 ? this.adjustmentList[0].totalrows : 0;
                    this.grandTotalAmountAdjust = this.adjustmentList.length > 0 ? this.adjustmentList[0].total_amount : 0;
                  }
                  else {
                    this.clearTotalAdjust();
                  }
                } else {
                  this.clearTotalAdjust();
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.clearTotalAdjust();
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getBonusList: function(isSearch) {
      if (this.checkDateRangeBonus()) {
        let url = config.bonusListUrl();

        if (isSearch) this.currentPageBonus = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          account_id: this.$store.getters.accountId,
          start_date: this.dateRangeBonus.startDate,
          end_date: this.dateRangeBonus.endDate,
          manual_bonus_only: this.manualBonus,
          sort_key: this.sortKeyBonus,
          sort_type: this.sortTypeBonus,
          page_number: this.currentPageBonus,
          page_size: this.getPageSize,
          member_id: this.member.account_id
        };

        // if (this.searchBonus.trim() != '')
        //   json.member_id = this.searchBonus;

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotalBonus();
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.ds.summarydetail.length > 0) {
                    this.showTotalBonus = true;
                    response.data.ds.summarydetail.forEach(value => {
                      this.subTotalAmountBonus = parseFloat(this.subTotalAmountBonus) + parseFloat(value["bonus_value"]);
                    });

                    if(response.data.ds.grand_total.length > 0) {
                      this.grandTotalAmountBonus = response.data.ds.grand_total[0]["bonus_value"];
                    }

                    this.bonusList = response.data.ds.summarydetail;
                    this.totalRowBonus = response.data.ds.summarydetail.length > 0 ? this.bonusList[0]["totalrows"] : 0
                  } else {
                    this.clearTotalBonus();
                  }
                } else {
                  this.clearTotalBonus();
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.clearTotalBonus();
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }

    },
    getProviderWinLose: function(isSearch) {
      if (this.checkDateRangeWinlose()) {
        let url = config.providerWinLoseMemberUrl();

        if (isSearch) this.currentPageWinlose = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          member_id: this.member.account_id,
          start_date: this.dateRangeWinlose.startDate,
          end_date: this.dateRangeWinlose.endDate,
          sort_type: this.sortTypeWinlose,
          sort_key: this.sortKeyWinlose,
          page_number: this.currentPageWinlose,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotalWinlose()
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.ds.winlose.length > 0) {
                    this.showTotalWinlose = true
                    response.data.ds.winlose.forEach(value => {
                      this.subTotalWinLoseProvider = parseFloat(this.subTotalWinLoseProvider) + parseFloat(value["winlose"]);
                      this.subTotalTurnoverProvider = parseFloat(this.subTotalTurnoverProvider) + parseFloat(value["turnover"]);
                      this.subTotalValidTurnoverProvider = parseFloat(this.subTotalValidTurnoverProvider) + parseFloat(value["valid_turnover"]);
                    });

                    if(response.data.ds.grand_total.length > 0) {
                      this.grandTotalWinLoseProvider = response.data.ds.grand_total[0]["winlose"];
                      this.grandTotalTurnoverProvider = response.data.ds.grand_total[0]["turnover"];
                      this.grandTotalValidTurnoverProvider = response.data.ds.grand_total[0]["valid_turnover"];
                    }

                    this.winloseList = response.data.ds.winlose
                    this.totalRowWinlose = this.winloseList.length > 0 ? this.winloseList[0].totalrows : 0;
                  } else {
                    this.clearTotalWinlose()
                  }
                } else {
                  this.clearTotalWinlose()
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.clearTotalWinlose();
        this.winloseList = [];
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getStatement: function(isSearch) {
      if (this.checkDateRangeStatement()) {
        let url = config.dailyStatementUrl();

        if (isSearch) this.currentPageStatement = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          account_id: this.member.account_id,
          start_date: this.dateRangeStatement.startDate,
          end_date: this.dateRangeStatement.endDate,
          sort_type: this.sortTypeStatement,
          page_number: this.currentPageStatement,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotalStatement()
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;

                if (this.feedback.success == true) {
                  if(response.data.ds.statement.length > 0) {
                    this.showTotalStatement = true;
                    response.data.ds.statement.forEach(value => {
                      this.subTotalTurnoverStatement = parseFloat(this.subTotalTurnoverStatement) + parseFloat(value["turnover"]);
                      this.subTotalValidTurnoverStatement = parseFloat(this.subTotalValidTurnoverStatement) + parseFloat(value["valid_turnover"]);
                      this.subTotalWinLoseStatement = parseFloat(this.subTotalWinLoseStatement) + parseFloat(value["winlose"]);
                      this.subTotalDepositAmountStatement = parseFloat(this.subTotalDepositAmountStatement) + parseFloat(value["deposit_amount"]);
                      this.subTotalWithdrawalAmountStatement = parseFloat(this.subTotalWithdrawalAmountStatement) + parseFloat(value["withdrawal_amount"]);
                      this.subTotalBonusAmountStatement = parseFloat(this.subTotalBonusAmountStatement) + parseFloat(value["bonus_amount"]);
                      this.subTotalAdjustmentAmountStatement = parseFloat(this.subTotalAdjustmentAmountStatement) + parseFloat(value["adjustment_amount"]);
                      this.subTotalRefereeCountStatement = parseInt(this.subTotalRefereeCountStatement) + parseInt(value["referee_count"]);
                    });


                    if(response.data.ds.grand_total.length > 0) {
                      this.grandTotalTurnoverStatement = response.data.ds.grand_total[0]["turnover"];
                      this.grandTotalValidTurnoverStatement = response.data.ds.grand_total[0]["valid_turnover"];
                      this.grandTotalWinLoseStatement = response.data.ds.grand_total[0]["winlose"];
                      this.grandTotalDepositAmountStatement = response.data.ds.grand_total[0]["deposit_amount"];
                      this.grandTotalWithdrawalAmountStatement = response.data.ds.grand_total[0]["withdrawal_amount"];
                      this.grandTotalBonusAmountStatement = response.data.ds.grand_total[0]["bonus_amount"];
                      this.grandTotalAdjustmentAmountStatement = response.data.ds.grand_total[0]["adjustment_amount"];
                      this.grandTotalRefereeCountStatement = response.data.ds.grand_total[0]["referee_count"];
                    }

                    this.statementList = response.data.ds.statement;
                    this.totalRowStatement = response.data.ds.statement.length > 0 ? this.statementList[0]["totalrows"] : 0
                  } else {
                    this.clearTotalStatement()
                  }
                } else {
                  this.clearTotalStatement()
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.clearTotalStatement();
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    redirectToTicketWalletTrans: function(item, type) {
      var json = {
        member_id: this.member.account_id,
        working_date: item.working_date,
        request_type: type
      };

      this.$store.dispatch("user/setTicketWalletTransListParam", json);
      this.$router.push("/report/ticketWalletTransList");
    },
    redirectToWL: function(item) {
      var json = {
        account_id: this.member.account_id,
        start_date: item.working_date,
        end_date: item.working_date
      };
      this.$store.dispatch("user/setWinLoseParam", json);
      this.$router.push("/report/platformWinLose");
    },
    redirectToAdjustment: function(item) {
      var json = {
        member_id: this.member.account_id,
        start_date: item.working_date,
        end_date: item.working_date
      };

      this.$store.dispatch("user/setAdjustmentListParam", json);
      this.$router.push("/report/adjustmentList");
    },
    redirectToBonus: function(item) {
      var json = {
        member_id: this.member.account_id,
        start_date: item.working_date,
        end_date: item.working_date
      };

      this.$store.dispatch("user/setBonusListParam", json);
      this.$router.push("/report/bonusList");
    },
    clearTotalSlots() {
      // this.sortKeySlots = "bet_time";
      // this.sortTypeSlots = "desc";
      // this.providerSlots = "";
      this.showTotalSlots = false;
      this.slotsList = []
      this.totalRowSlots = 0
      this.subTotalTurnoverSlots = 0
      this.grandTotalTurnoverSlots = 0
      this.subTotalValidTurnoverSlots = 0
      this.grandTotalValidTurnoverSlots = 0
      this.subTotalWinLoseSlots = 0
      this.grandTotalWinLoseSlots = 0
      this.subTotalPayoutSlots = 0
      this.grandTotalPayoutSlots = 0
    },
    clearTotalLivecasino() {
      // this.sortKeyLivecasino = "bet_time";
      // this.sortTypeLivecasino = "desc";
      // this.providerLivecasino = "";
      this.showTotalLivecasino = false;
      this.livecasinoList = []
      this.totalRowLivecasino = 0
      this.subTotalTurnoverLivecasino = 0
      this.grandTotalTurnoverLivecasino = 0
      this.subTotalValidTurnoverLivecasino = 0
      this.grandTotalValidTurnoverLivecasino = 0
      this.subTotalWinLoseLivecasino = 0
      this.grandTotalWinLoseLivecasino = 0
      this.subTotalPayoutLivecasino = 0
      this.grandTotalPayoutLivecasino = 0
    },
    clearTotalRebate() {
      // this.sortKeyRebate = "bet_time";
      // this.sortTypeRebate = "desc";
      this.showTotalRebate = false;
      this.rebateList = []
      this.totalRowRebate = 0
      this.subTotalTurnoverRebate = 0
      this.grandTotalTurnoverRebate = 0
      this.subTotalValidTurnoverRebate = 0
      this.grandTotalValidTurnoverRebate = 0
      this.subTotalWinLoseRebate = 0
      this.grandTotalWinLoseRebate = 0
      this.subTotalPayoutRebate = 0
      this.grandTotalPayoutRebate = 0
    },
    clearTotalSportsbook() {
      // this.sortKeySportsbook = "bet_time";
      // this.sortTypeSportsbook = "desc";
      this.showTotalSportsbook = false;
      this.sportsbookList = []
      this.totalRowSportsbook = 0
      this.subTotalTurnoverSportsbook = 0
      this.grandTotalTurnoverSportsbook = 0
      this.subTotalValidTurnoverSportsbook = 0
      this.grandTotalValidTurnoverSportsbook = 0
      this.subTotalWinLoseSportsbook = 0
      this.grandTotalWinLoseSportsbook = 0
      this.subTotalPayoutSportsbook = 0
      this.grandTotalPayoutSportsbook = 0
    },
    clearTotalCockfight() {
      // this.sortKeyCockfight = "bet_time";
      // this.sortTypeCockfight = "desc";
      this.showTotalCockfight = false;
      this.cockfightList = []
      this.totalRowCockfight = 0
      this.subTotalTurnoverCockfight = 0
      this.grandTotalTurnoverCockfight = 0
      this.subTotalValidTurnoverCockfight = 0
      this.grandTotalValidTurnoverCockfight = 0
      this.subTotalWinLoseCockfight = 0
      this.grandTotalWinLoseCockfight = 0
      this.subTotalPayoutCockfight = 0
      this.grandTotalPayoutCockfight = 0
    },
    clearTotalRescue() {
      // this.sortKeyRescue = "bet_time";
      // this.sortTypeRescue = "desc";
      this.showTotalRescue = false;
      this.rescueList = []
      this.totalRowRescue = 0
      this.subTotalTurnoverRescue = 0
      this.grandTotalTurnoverRescue = 0
      this.subTotalValidTurnoverRescue = 0
      this.grandTotalValidTurnoverRescue = 0
      this.subTotalWinLoseRescue = 0
      this.grandTotalWinLoseRescue = 0
      this.subTotalPayoutRescue = 0
      this.grandTotalPayoutRescue = 0
    },
    clearTotalAdjust() {
      this.showTotalAdjust = false
      this.adjustmentList = []
      this.totalRowAdjust = 0
      this.subTotalAmountAdjust = 0
      this.grandTotalAmountAdjust = 0
    },
    clearTotalWinlose() {
      this.showTotalWinlose = false;
      this.winloseList = []
      this.subTotalWinLoseProvider = 0
      this.grandTotalWinLoseProvider = 0
      this.subTotalTurnoverProvider = 0
      this.grandTotalTurnoverProvider = 0
      this.subTotalValidTurnoverProvider = 0
      this.grandTotalValidTurnoverProvider = 0
    },
    clearTotalStatement() {
      this.showTotalStatement = false
      this.statementList = []
      this.totalRowStatement = 0
      this.subTotalTurnoverStatement = 0
      this.grandTotalTurnoverStatement = 0
      this.subTotalValidTurnoverStatement = 0
      this.grandTotalValidTurnoverStatement = 0
      this.subTotalWinLoseStatement = 0
      this.grandTotalWinLoseStatement = 0
      this.subTotalDepositAmountStatement = 0
      this.grandTotalDepositAmountStatement = 0
      this.subTotalWithdrawalAmountStatement = 0
      this.grandTotalWithdrawalAmountStatement = 0
      this.subTotalBonusAmountStatement = 0
      this.grandTotalBonusAmountStatement = 0
      this.subTotalAdjustmentAmountStatement = 0
      this.grandTotalAdjustmentAmountStatement = 0
      this.subTotalRefereeCountStatement = 0
      this.grandTotalRefereeCountStatement = 0
    },
    clearTotalBonus() {
      this.showTotalBonus = false
      this.bonusList = []
      this.totalRowBonus = 0
      this.subTotalAmountBonus = 0
      this.grandTotalAmountBonus = 0
    },
    onUnblock: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.unblock"),
          text: this.$t("message.unblock_member_confirm", { name: item.account_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmUnblock(item);
          }
        });
    },
    confirmUnblock: function(item) {
      let url = config.memberUnblockUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        member_id: item.account_id,
        audit_by: this.$store.getters.loginId
      };

      this.feedback.success = true;
      // this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          // this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                item.status = "ACTIVE";
                this.$helpers.showDialog(this.$t("ui.unblock_member"), this.$t("message.success"), "success");
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    changedMemberStatus: function(member, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_member_status_confirm", { name: member.account_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmMemberStatus(member, eventStatus.srcElement.value);
          } else {
            eventStatus.srcElement.value = member.status;
          }
        });
    },
    confirmMemberStatus: function(member, status) {
      let url = config.memberStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        member_id: member.account_id,
        new_status: status,
        audit_by: this.$store.getters.loginId
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                member.status = status;
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.loading = false;
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    afterResetPasswordMember: function() {
      this.getMemberSummary();
      this.$helpers.showDialog(this.$t("ui.combine.reset_password"), this.$t("message.success"), "success");
    },
    afterAdjustMember: function() {
      this.getMemberSummary();
      this.$helpers.showDialog(this.$t("ui.combine.adjust_member"), this.$t("message.success"), "success");
    },
    afterEditMember: function() {
      this.getMemberSummary();
      this.$helpers.showDialog(this.$t("ui.combine.edit_member"), this.$t("message.success"), "success");
    },
    afterRaiseDepositTicket: function() {
      this.getMemberSummary();
      this.$helpers.showDialog(this.$t("ui.combine.raise_deposit_ticket"), this.$t("message.success"), "success");
    },
    afterIssueBonus: function() {
      this.getMemberSummary();
      this.$helpers.showDialog(this.$t("ui.combine.bonus_issue"), this.$t("message.success"), "success");
    },
    afterPromoMemberAssign: function() {
      this.getMemberSummary();
      this.$helpers.showDialog(this.$t("ui.combine.promo_member_assign"), this.$t("message.success"), "success");
    },
    afterUpdateVip: function() {
      this.getMemberSummary();
      this.$helpers.showDialog(this.$t("ui.combine.update_vip"), this.$t("message.success"), "success");
    },
    afterUpdateMemberProfile: function() {
      this.getMemberSummary();
      this.$helpers.showDialog(this.$t("ui.combine.update_member_profile"), this.$t("message.success"), "success");
    },
    afterUpdateMemberBetLimit: function() {
      this.getMemberSummary();
      this.$helpers.showDialog(this.$t("ui.combine.update_member_bet_limit"), this.$t("message.success"), "success");
    },
    afterClearOutstanding: function(amt) {
      this.getMemberSummary();
      this.$helpers.showDialog(this.$t("ui.combine.clear_outstanding"), this.$t("message.successful_clear_outstanding", { amt: this.$n(amt, 'currency') }), "success");
    },
    afterRaiseDepositTicketGateway: function() {
      this.getMemberSummary();
      this.$helpers.showDialog(this.$t("ui.combine.raise_deposit_ticket_gateway"), this.$t("message.success"), "success");
    },
    afterUpsertLabel: function() {
      this.getMemberSummary();
      this.$helpers.showDialog(this.$t("ui.combine.edit_label"), this.$t("message.success"), "success");
    },
    afterIssueFreeSpin: function() {
      this.getMemberSummary();
      this.$helpers.showDialog(this.$t("ui.combine.issue_free_spin"), this.$t("message.success"), "success");
    },
    changedPageSizeSlots: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPageSlots = 1;
      this.getGameResultSlots(true);
    },
    changedPageSlots: function(pageNo) {
      this.currentPageSlots = pageNo;
      this.getGameResultSlots();
    },
    changedPageSizeLivecasino: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPageLivecasino = 1;
      this.getGameResultLivecasino(true);
    },
    changedPageLivecasino: function(pageNo) {
      this.currentPageLivecasino = pageNo;
      this.getGameResultLivecasino();
    },
    changedPageSizeRebate: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPageRebate = 1;
      this.getGameResultRebate(true);
    },
    changedPageRebate: function(pageNo) {
      this.currentPageRebate = pageNo;
      this.getGameResultRebate();
    },
    changedPageSizeSportsbook: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPageSportsbook = 1;
      this.getGameResultSportsbook(true);
    },
    changedPageSportsbook: function(pageNo) {
      this.currentPageSportsbook = pageNo;
      this.getGameResultSportsbook();
    },
    changedPageSizeCockfight: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPageCockfight = 1;
      this.getGameResultCockfight(true);
    },
    changedPageCockfight: function(pageNo) {
      this.currentPageCockfight = pageNo;
      this.getGameResultCockfight();
    },
    changedPageSizeRescue: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPageRescue = 1;
      this.getGameResultRescue(true);
    },
    changedPageRescue: function(pageNo) {
      this.currentPageRescue = pageNo;
      this.getGameResultRescue();
    },
    changedPageSizeIp: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPageIp = 1;
      this.getIpAssociateList(true);
    },
    changedPageIp: function(pageNo) {
      this.currentPageIp = pageNo;
      this.getIpAssociateList();
    },
    changedPageSizeAudit: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPageAudit = 1;
      this.getAuditLoginMemberList(true);
    },
    changedPageAudit: function(pageNo) {
      this.currentPageAudit = pageNo;
      this.getAuditLoginMemberList();
    },
    changedPageSizeAdjust: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPageAdjust = 1;
      this.getAdjustmentList(true);
    },
    changedPageAdjust: function(pageNo) {
      this.currentPageAdjust = pageNo;
      this.getAdjustmentList();
    },
    changedPageSizeBonus: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPageBonus = 1;
      this.getBonusList(true);
    },
    changedPageBonus: function(pageNo) {
      this.currentPageBonus = pageNo;
      this.getBonusList();
    },
    changedPageSizeWinlose: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPageWinlose = 1;
      this.getProviderWinLose(true);
    },
    changedPageWinlose: function(pageNo) {
      this.currentPageWinlose = pageNo;
      this.getProviderWinLose();
    },
    changedPageSizeStatement: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPageStatement = 1;
      this.getStatement(true);
    },
    changedPageStatement: function(pageNo) {
      this.currentPageStatement = pageNo;
      this.getStatement();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    },
    closeModal: function() {
      this.$refs.memberDetails.hide();
    },
  }
};
</script>
<style lang="scss">
.badge {
  padding: 2.5px 4px !important;
}
.text-value {
  h1 {
    overflow:hidden !important;
    text-overflow:ellipsis !important;
    white-space: nowrap !important;
  }
}
</style>
